// dependecies import ==>
import React, { useContext, useEffect, useRef, useState } from "react";
import { Drawer } from "@mui/material";
import moment from "moment";
import { v4 as uuid } from "uuid";
import swal from "sweetalert";
// assets and scss import ==>
import "./erxViewContainer.scss";
import warning from "../../assets/warning.png";
import question from "../../assets/question.svg";
import CollapseIcon from "../../assets/rx_expand.svg";
// project file import ==>
import ERXMain from "./ERXMain";
import PastPrescription from "../PrescriptionTabComponent/PastPrescription";
import Loader from "../UI Component/Loader/Loader";
import PEMShareContentPopUp from "../PEM";
import Popup from "../PEM/common/Popup";
import PrescriptionSharedModal from "../UI Component/Modal/PrescriptionSharedModal";
import ERXMiniMapping from "./ERXMiniMapping";
import GrowthChart from "./ERXMain/GrowthChart";
import ERXViewHeader from "./ERXViewHeader";
import ERXViewFooter from "./ERXViewFooter";
import useDebounce from "./common/debounce";
import FilesView from "./ERXMain/FilesView/index.js";
import UMPView from "./ERXMain/UMPView/index.js";
import SSPView from "./ERXMain/SSPView/index.js";
import VCView from "./ERXMain/VCView/index.js";
import CommonPopup from "../common/CommonPopup";
import { getGrowthGraph } from "./ERXMain/GrowthChart/GrowthChartGraph/growthGraphIndexDB";
import SaveTemplateView from "./ERXViewFooter/SaveTemplateView";
import ErxPreviewContainerView from "./ErxPreviewContainerView";
// constant import ==>
import { viewFollowUpDate } from "../../components/DashboardAppointmentsView/DashboardAppointmentsViewApiHandler/index.js";
import {
  ERXComponents,
  GENDER_MENU_OPTIONS,
  ADD_RECORD_LIST,
  FOLLOW_UP_LIST,
  PATIENT_HISTORY_AND_COMPLAINTS,
  SELECTION_LIST_TITLES,
  FOLLOW_UP_EVENTS,
  VITALS_LIST,
  CUSTOM_BUTTON_STATUS,
  OBSTETRIC_HISTORY_INPUTS,
  SELECTED_TAB_LIST,
  DEFAULT_OBSTETRIC_DETAILS,
  ALLOWED_SPECIALIZATIONS_FOR_OBSTETRIC_DETAILS,
  DEFAULT_API_LOADERS,
  SECTIONAL_TEMPLATES,
} from "./ERXConstants/constants";
import { addUpdatePrescriptionData, getDoctorNotes } from "./ERXViewApiHandler";
import {
  GET_SAVED_E_PRESCRIPTIONS,
  GET_PATIENT_DETAILS,
  ADD_EDIT_VITALS,
  GET_PATIENT_VITALS,
  GET_PRESCRIPTION_DATA,
  ADD_UPDATE_HISTORY_AND_COMPLAINTS,
  GET_ERX_TEMPLATE_DATA,
  GET_PREVIOUS_PRESCRIPTION,
  GET_PRESCRIPTION_ID,
  GET_SAVED_TEMPLATES,
  GET_PAST_CONSULTATIONS,
  GET_USER_SETTINGS,
  UPDATE_USER_SETTINGS,
  ADD_FOLLOWUP_DATE,
  ADD_EDIT_PRESCRIPTION,
  GET_VACCINE_CHART,
  APPROVE_AND_SHARE_ERX,
  PRINT_GROW_CHART,
  GET_PATIENT_HISTORY_SUGGESTIONS,
  GET_INSTRUCTION_SUGGESTIONS,
  GET_DRUGS_SUGGESTIONS,
  SAVE_TEMPLATE,
  CREATE_SECTION_TEMPLATE,
  DELETE_SECTION_TEMPLATE,
  GET_SECTION_TEMPLATE,
  GET_PHARMACY_LIST,
  SHARE_RX_WITH_PHARMACY,
} from "./ERXViewApiHandler/apiConstants";
import { APPLICABLE_ROLE } from "../DashboardAppointmentsView/Constant";
import {
  getAgeInYearsMonthDays,
  getDrugDropDownOptions,
  getDueDates,
  getHistoryAndComplaintPayload,
  getInstructionAndNotesPayload,
  getObstetricHistoryPayload,
  getPayloadForDrug,
  getSuggestedInvestigationPayload,
  saveDrugDataHelper,
} from "./helper.js";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import AlertMsgPopup from "../common/AlertMsgPopup/index.js";
import { GET_ALL_VACCINES } from "./ERXMain/VCView/VCViewApiHandler/apiConstants";
import {
  c2cDeleteApiHandler,
  c2cGetApiHandler,
  c2cPostApiHandler,
} from "../../Util/c2cApiHandler/index.js";
import DoctorContext from "../ClinicComponents/ClinicWrapper/DoctorContext.js";
import ShareWithPharmacyPopup from "./common/ShareWithPharmacyPopup/index.js";
import StaffAlertMessagePopup from "../common/StaffAlertMessgePopup/index.js";

const ERXViewContainer = (props) => {
  const { drawerOpen, appointmentData, toggleDrawer, setErxComponentOpen } =
    props;
  const dragItem = useRef();
  const dragOverItem = useRef();
  const previewLoaderRef = useRef(null);
  const user_id = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const user_type = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const staff_id = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const patientDob = appointmentData?.patient_dob;
  const allowedObstetricDetailsSpecializations =
    ALLOWED_SPECIALIZATIONS_FOR_OBSTETRIC_DETAILS;

  const [showPrescriptionHome, setShowPrescriptionHome] = useState(
    SELECTED_TAB_LIST.HOME
  );
  const [erxComponents, setErxComponents] = useState(
    JSON.parse(JSON.stringify(ERXComponents))
  );
  const [editedPayload, setEditedPayload] = useState({
    appointment_id: appointmentData?.appointment_id,
    user_type: user_type,
    user_id: user_id,
  });
  const frequencyList = [...FOLLOW_UP_EVENTS];
  const [selectedDays, setSelectedDays] = useState("");
  const [fileList, setFileList] = useState([]);
  const [docList, setDocList] = useState([]);
  const [patientDetails, setPatientDetails] = useState({
    patient_name: "",
    patient_dob: "",
    patient_gender: "",
  });
  const [updatedGender, setUpdatedGender] = useState();
  const [patientAge, setPatientAge] = useState("");
  const [genderOptions, setGenderOptions] = useState(
    JSON.parse(JSON.stringify(GENDER_MENU_OPTIONS))
  );
  const [templateName, setTemplateName] = useState({ name: "", id: "" });
  const [templateError, setTemplateError] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [addEditVitals, setAddEditVitals] = useState({
    call_api: false,
    value: {},
  }); /// spread this object on save and share prescription payload
  const [vitalsForPrefill, setVitalsForPrefill] = useState([]);
  const [vitalsList, setVitalsList] = useState(
    JSON.parse(JSON.stringify(VITALS_LIST))
  );
  const [enableLeadsDashboard, setEnableLeadsDashboard] = useState(false);
  const doctorContext = useContext(DoctorContext);
  const [loader, setLoader] = useState(false);
  const [doctorNote, setDoctorNote] = useState({ call_api: false, value: "" });
  const [doctorsPastNotes, setDoctorsPastNotes] = useState([]);
  const [maxApiCallForNotes, setMaxApiCallForNotes] = useState(1);
  const [patient_history_and_complaints, setPatientHistoryAndComplaints] =
    useState(JSON.parse(JSON.stringify(PATIENT_HISTORY_AND_COMPLAINTS)));
  const [followUpDate, setFollowUpDate] = useState({
    call_api: false,
    value: "",
  });
  const [followUp, setFollowUp] = useState(
    JSON.parse(JSON.stringify(FOLLOW_UP_LIST))
  );
  const [prescription_id, setPrescriptionId] = useState("");
  const [createdPrescriptionId, setCreatedPrescriptionId] = useState("");
  const [diagnosisList, setDiagnosisList] = useState({
    call_api: false,
    value: [{ title: "", description: "", value: { id: 1 }, id: 1 }],
  });
  const [reportList, setReportList] = useState({
    call_api: false,
    value: [{ title: "", description: "", value: { id: 1 }, id: 1 }],
  });
  const [templatesList, setTemplatesList] = useState([]);
  const [pastConsultationsList, setPastConsultationsList] = useState([]);
  const [drugList, setDrugList] = useState({
    call_api: false,
    updateState: false,
    value: [],
    templateSelected: false,
  });
  const [addRecordList, setAddRecordList] = useState(
    JSON.parse(JSON.stringify(ADD_RECORD_LIST))
  );
  const [showPEMPopUp, setShowPEMPopUp] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [showPrescriptionShareModal, setShowPrescriptionShareModal] =
    useState(false);
  const [showSettingUi, setShowSettingUi] = useState(0);
  const [frequencyOptions, setFrequencyOption] = useState([]);
  const [frequencyDetailsOptions, setFrequencyDetailsOption] = useState([]);
  const [durationOptions, setDurationOptions] = useState([]);
  const [vaccineNotes, setVaccineNotes] = useState({
    call_api: false,
    value: "",
  });
  const [pastVitalsSetting, setPastVitalsSetting] = useState(false);
  const [includeErx, setIncludeErx] = useState({
    Vitals: true,
    Diagnosis: true,
    PatientExamination: true,
  });
  const [draggable, setDraggable] = useState(true);
  const [disablePreview, setDisablePreview] = useState(false);
  const [deletedDrug, setDeletedDrug] = useState([]);
  const [showEditGrowthChart, setShowEditGrowthChart] = useState(false);
  const [redirectItem, setRedirectItem] = useState(null);
  const [openBackToErxPopup, setOpenBackToErxPopup] = useState(false);
  const [openPrintChartPopup, setOpenPrintChartPopup] = useState(false);
  const [isTemplateSelected, setIsTemplateSelected] = useState(false);
  const [callGrowthChartVitals, setCallGrowthChartVitals] = useState(false);
  const [drugsSuggestionList, setDrugsSuggestionList] = useState([]);
  const [instructionSuggestionList, setInstructionSuggestionList] = useState(
    []
  );

  const [documentDetils, setDocumentDetails] = useState({
    documentID: "",
    erxType: "",
  });

  const [sectionalTemplateList, setSectionalTemplateList] = useState({});
  const [alertMesg, setAlertMesg] = useState("You have saved your template");

  const [phcSuggestionObj, setPHCSuggestionObj] = useState({
    chief_complaints: [],
    past_medical_history: [],
    lifestyle_history: [],
    menstrual_history: [],
    family_history: [],
  });
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [quantityOptions, setQuantityOption] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState({
    name: "",
    id: "",
  });
  const [obstetricHistoryList, setObstetricHistoryList] = useState({
    ...JSON.parse(JSON.stringify(OBSTETRIC_HISTORY_INPUTS)),
  });
  const [customSection, setCustomSection] = useState({
    call_api: false,
    value: {},
  });
  const [defaultTemplateId, setDefaultTemplateId] = useState();
  const [patientPhoneNo, setPatientPhoneNo] = useState("");
  const debounceForCustomSection = useDebounce(customSection, 500);
  const [savePrescriptionTemplate, setSavePrescriptionTemplate] =
    useState(false);

  const [hideShowShareSavedPrescription, setHideShowShareSavedPrescription] =
    useState(false);
  const [hideShowPastPrescription, setHideShowPastPrescription] =
    useState(false);
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const [patientDetailsName, setPatientDetailsName] = useState("");
  const [isPatientDetailsPopupOpen, setPatientDetailsPopupOpen] =
    useState(false);
  const [vaccineList, setVaccineList] = useState([]);
  const [generalVaccineList, setGeneralVaccineList] = useState([]);
  const [isAgeAboveSixteen, setIsAgeAboveSixteen] = useState(false);
  const [vaccineVitalsList, setVaccineVitalsList] = useState({});
  const [searchVaccine, setSearchVaccine] = useState("");
  const [obstetricDetails, setObstetricDetails] = useState(
    JSON.parse(JSON.stringify(DEFAULT_OBSTETRIC_DETAILS))
  );
  const [doctorSpecialization, setDoctorSpecialization] = useState("");
  const [selectedSectionTemp, setSelectedSectionTemp] = useState({
    [SECTIONAL_TEMPLATES.SUGGESTED_INVESTIGATION_TEMPLATE]: "",
    [SECTIONAL_TEMPLATES.DIAGNOSIS_TEMPLATE]: "",
    [SECTIONAL_TEMPLATES.DRUG_TEMPLATE]: "",
  });
  const [previewLoader, setPreviewLoader] = useState(false);
  const [apiLoaders, setApiLoaders] = useState(
    JSON.parse(JSON.stringify(DEFAULT_API_LOADERS))
  );
  const [isPreviewClicked, setIsPreviewClicked] = useState(false);
  const [approveAndShareLoader, setApproveAndShareLoader] = useState(false);
  const [showSharePopUp, setShowSharePopUp] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [defaultPharmacy, setDefaultPharmacy] = useState(false);
  const [pharmacyList, setPharmacyList] = useState([]);
  const [isAnyPharmacySelected, setIsAnyPharmacySelected] = useState(false);
  const [selectedPharmacyList, setSelectedPharmacyList] = useState([]);

  // Lifecycle Methods ===>

  useEffect(() => {
    setEnableLeadsDashboard(doctorContext?.enableLeadsDashboard);
  }, [doctorContext?.enableLeadsDashboard]);
  useEffect(() => {
    setTemplateName({ name: "", id: "" });
    setTemplateError(false);
    setIsChecked(false);
    getSectionSettings();
    getPharmacyList();
    if (!appointmentData?.prescription_status) {
      setShowEditGrowthChart(false);
    } else {
      setShowEditGrowthChart(true);
    }
    getPatientDetailsApi();
    getTemplatesApi();
    vitalsList.forEach((item) => {
      if (item.unit === "") {
        item.unit = item.unitList[0];
      }
    });
    setVitalsList([...vitalsList]);
    setTimeout(() => {
      fetchVitals();
    }, 10);
    getPastConsultationsApi();
    setLoader(true);
    getGrowthGraph();
    getSectionalTemplates();
  }, []);

  useEffect(() => {
    updateSelectedSectionTemp();
  }, [selectedSectionTemp]);

  useEffect(() => {
    const anySelected = pharmacyList.some((pharmacy) => pharmacy.selected);
    setIsAnyPharmacySelected(anySelected);
  }, [pharmacyList]);

  useEffect(() => {
    const updatedPharmacyList = pharmacyList.map((pharmacy) => {
      const matchingSelectedPharmacy = selectedPharmacyList.find(
        (selected) => selected.pharmacy_id === pharmacy.pharmacy_id
      );

      return {
        ...pharmacy,
        selected: matchingSelectedPharmacy
          ? matchingSelectedPharmacy.selected
          : false,
      };
    });
    setPharmacyList(updatedPharmacyList);
  }, [selectedPharmacyList]);

  useEffect(() => {
    if (prescription_id) {
      setDoctorsPastNotes([]);
      getDoctorsPastNotes(prescription_id, 1, true);
      getVaccines();
    }
  }, [prescription_id]);

  useEffect(() => {
    let payload = {};
    vitalsList.forEach((obj) => {
      payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}`] = obj.value;
      payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}_unit`] = obj.unit;
    });
    setEditedPayload({ ...editedPayload, ...payload });
  }, [vitalsList]);

  useEffect(() => {
    afterFetchingVitals();
  }, [vitalsForPrefill]);

  // Do Not Remove this useEffect.
  useEffect(() => {
    scheduleFollowUp();
  }, []);

  useEffect(() => {
    callSuggestedListAPI();
  }, []);

  useEffect(() => {
    if (debounceForCustomSection?.call_api) {
      handleUpdateAPICall();
    }
  }, [debounceForCustomSection]);

  // the loader is shown beside preview button even if one of the api calls is still running and the loader stops when all the api calls has ended
  useEffect(() => {
    let showLoader = apiLoaders.some((ele) => ele.loader);
    setPreviewLoader(showLoader);
  }, [apiLoaders]);

  useEffect(() => {
    previewLoaderRef.current = previewLoader;
  }, [previewLoader]);

  // <===

  // Actions ===>

  const handleSharePharmacyBtn = (documentId, erxType) => {
    setShowSharePopUp(true);
    setDocumentDetails({
      documentID: documentId,
      erxType: erxType,
    });
  };

  const handleCloseSharePopup = () => {
    setShowSharePopUp(false);
  };

  const handleSharePharmacy = () => {
    setShowSharePopUp(false);
    updateSharePharmacySettings();
    updateShareErxWithPharmacy();
  };

  const handleSelectPharmacy = (item) => {
    setPharmacyList((prevList) => {
      const updatedList = prevList.map((pharmacy) =>
        pharmacy.pharmacy_id === item.pharmacy_id
          ? { ...pharmacy, selected: !pharmacy.selected }
          : pharmacy
      );
      return updatedList;
    });
  };

  const handleCloseAlertMsg = () => {
    setAlertMessage({
      show: false,
      title: "",
      content: "",
      type: "",
    });
  };

  const onDragStart = (e, pos) => {
    dragItem.current = pos;
  };

  const onDragEnter = (e, pos) => {
    dragOverItem.current = pos;
  };
  const drop = (e) => {
    if (dragOverItem.current !== 16) {
      const dragItemContent = erxComponents[dragItem.current];
      erxComponents.splice(dragItem.current, 1);
      erxComponents.splice(dragOverItem.current, 0, dragItemContent);
      dragItem.current = null;
      dragOverItem.current = null;
      setErxComponents([...erxComponents]);
    }

    erxComponents.forEach((ob, index) => {
      ob.position = index;
    });

    setErxComponents([...erxComponents]);
    updateSectionSettings();
  };

  const settingIconClick = (id) => {
    if (id !== 0) {
      let comp = [...erxComponents];
      let indx = comp.findIndex((ob) => ob.id === id);
      comp[indx].expand = true;
      setErxComponents([...comp]);
    }
    setShowSettingUi(id);
  };
  const handleSetting = (ques, ans, compIndx) => {
    let erxDupe = [...erxComponents];
    let indx = erxDupe[compIndx].settings.findIndex(
      (obj) => obj.question === ques
    );
    if (indx > -1) {
      erxDupe[compIndx].settings[indx].answer = ans;
      if (erxDupe[compIndx].settings[indx].que_key === "includeInErx") {
        includeErx[erxDupe[compIndx].name] = ans;
        setIncludeErx({ ...includeErx });
      }
      if (erxDupe[compIndx].settings[indx].que_key === "hidePastVitals") {
        setPastVitalsSetting(ans);
      }
    }
    setErxComponents([...erxDupe]);
    updateSectionSettings();
  };

  const updateSelectedSectionTemp = () => {
    if (
      selectedSectionTemp[SECTIONAL_TEMPLATES.SUGGESTED_INVESTIGATION_TEMPLATE]
        .section_details
    ) {
      let insAndNotes = followUp.value?.find(
        (ob) => ob?.name === "instructions_and_notes"
      );

      setFollowUp({
        ...followUp,
        call_api: true,
        value: [
          selectedSectionTemp[
            SECTIONAL_TEMPLATES.SUGGESTED_INVESTIGATION_TEMPLATE
          ].section_details,
          { ...insAndNotes },
        ],
      });
    }
    if (
      selectedSectionTemp[SECTIONAL_TEMPLATES.DRUG_TEMPLATE].section_details
    ) {
      let deletedDrugs = [];
      drugList.value.forEach((ele) => {
        let ind = selectedSectionTemp[
          SECTIONAL_TEMPLATES.DRUG_TEMPLATE
        ].section_details.findIndex((item) => item.id === ele.id);
        if (ind === -1) {
          deletedDrugs.push({ ...ele, deleted_at: "NOW()" });
        }
      });

      let newArr = [...deletedDrug, ...deletedDrugs];
      setDeletedDrug(newArr);
      setDrugList({
        ...drugList,
        call_api: true,
        value:
          selectedSectionTemp[SECTIONAL_TEMPLATES.DRUG_TEMPLATE]
            .section_details,
        templateSelected: true,
      });
    }
    if (
      selectedSectionTemp[SECTIONAL_TEMPLATES.DIAGNOSIS_TEMPLATE]
        .section_details
    ) {
      setDiagnosisList({
        ...diagnosisList,
        call_api: true,
        value:
          selectedSectionTemp[SECTIONAL_TEMPLATES.DIAGNOSIS_TEMPLATE]
            .section_details,
      });
    }
  };

  const afterFetchingVitals = () => {
    let fetchedData = vitalsForPrefill;
    let duplicatedList = vitalsList;
    if (fetchedData?.length > 0) {
      let prefillData = fetchedData[0];
      duplicatedList.map((obj) => {
        Object.keys(fetchedData[0]).forEach((key) => {
          if (key.toLowerCase() === obj.name?.replace(" ", "_").toLowerCase()) {
            if (key.toLowerCase() === "bmi") {
              obj.value = prefillData[key]?.toFixed(2);
            } else {
              obj.value = prefillData[key];
            }
          }
          if (`${obj.name.toLowerCase()}_unit` === key.toLowerCase()) {
            obj.unit = prefillData[key];
          }
        });
      });
      setVitalsList([...duplicatedList]);
      let payload = {};
      vitalsList.forEach((obj) => {
        payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}`] = obj.value;
        payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}_unit`] =
          obj.unit;
      });
      setEditedPayload({ ...editedPayload, ...payload });
      setAddEditVitals({ call_api: false, value: editedPayload });
    }
  };

  const updateDiagnosis = (val) => {
    let a = [
      {
        title: val,
        description: "",
        value: { title: val, value: val, label: val },
      },
    ];
    if (
      diagnosisList?.value?.length === 0 ||
      (diagnosisList.value[diagnosisList?.value?.length - 1].title === "" &&
        diagnosisList.value[diagnosisList?.value?.length - 1].description ===
          "")
    ) {
      if (diagnosisList?.value?.length > 1) {
        let filterEmpty = diagnosisList?.value?.filter(
          (o) =>
            (o.title !== "" && o.title !== undefined) ||
            (o.description?.trim() !== "" && o.description !== undefined)
        );
        let arr = [...filterEmpty, ...a];
        setDiagnosisList({ call_api: false, value: [...arr] });
      } else {
        setDiagnosisList({ call_api: false, value: [...a] });
      }
    } else {
      let filterEmpty = diagnosisList?.value?.filter(
        (o) =>
          (o.title !== "" && o.title !== undefined) ||
          (o.description?.trim() !== "" && o.description !== undefined)
      );
      let arr = [...filterEmpty, ...a];
      setDiagnosisList({ call_api: false, value: [...arr] });
    }
  };
  const toggleSections = (val) => {
    let ind = erxComponents.findIndex((comp) => comp.id === val.id);
    erxComponents[ind].expand = !erxComponents[ind].expand;
    setErxComponents([...erxComponents]);
    updateSectionSettings();
  };

  const handleShowPrescriptionsHome = (val) => {
    setShowPrescriptionHome(val);
  };

  const handlePatientName = (e) => {
    patientDetails.patient_name = e.target.value;
    setPatientDetails({ ...patientDetails });
  };

  const handlePatientAge = (data) => {
    setPatientAge(data);
  };

  const handleGender = (item) => {
    patientDetails.patient_gender = item.label;
    let ind = genderOptions.findIndex((ele) => ele.id === item.id);
    genderOptions.forEach((ele) => {
      ele.selected = false;
    });
    genderOptions[ind].selected = true;
    setGenderOptions([...genderOptions]);
    setPatientDetails({ ...patientDetails });
  };

  const handleClosePopup = () => {
    setPatientDetailsPopupOpen(false);
  };

  const handleDeleteFile = (ind) => {
    fileList.splice(ind, 1);
    setFileList([...fileList]);
  };

  const handleOnDrag = (e, key) => {
    e.preventDefault();
    let files = e.dataTransfer.files;
    calcTotalFileSize(files, e, key);
  };

  const handleFileChange = (e, key) => {
    let files = e.target.files;
    calcTotalFileSize(files, e, key);
  };

  const handleTemplateName = (e) => {
    setTemplateName({ name: e.target.value, id: "" });
  };

  const toggleCheckbox = () => {
    setIsChecked(!isChecked);
  };

  const handlePatientHistoryAndComplaints = (data) => {
    setPatientHistoryAndComplaints({ call_api: true, value: data });
  };

  const handleFollowUp = (call_api, data) => {
    setFollowUp({ call_api: call_api, value: data });
  };

  const handleDiagnosis = (call_api, data) => {
    setDiagnosisList({ call_api: call_api, value: data });
  };

  const handleReport = (call_api, data) => {
    setReportList({ call_api: call_api, value: data });
  };

  const handleSelectedTemplate = (selected_data) => {
    setSelectedTemplate({
      name: selected_data?.template_name,
      id: selected_data?.template_id ?? "",
    });
    let index = "";
    if (selected_data?.template_id) {
      index = templatesList.findIndex(
        (template) => template.template_id === selected_data.template_id
      );
    } else {
      index = templatesList.findIndex(
        (template) => template.prescription_id === selected_data.prescription_id
      );
    }

    templatesList.forEach((template) => {
      if (selected_data?.template_id) {
        if (template.template_id !== selected_data.template_id) {
          template.selected = false;
        }
      } else {
        if (template.prescription_id !== selected_data.prescription_id) {
          template.selected = false;
        }
      }
    });
    if (!templatesList[index].selected) {
      templatesList[index].selected = !templatesList[index].selected;
    }
    handleTemplateSelection(selected_data);
    pastConsultationsList.forEach((pastConsultation) => {
      pastConsultation.selected = false;
    });
    setPastConsultationsList([...pastConsultationsList]);
    setTemplatesList([...templatesList]);
    let duplicatedSectionTemp = { ...selectedSectionTemp };
    Object.keys(duplicatedSectionTemp).forEach((key) => {
      duplicatedSectionTemp[key] = "";
    });
    setSelectedSectionTemp(duplicatedSectionTemp);
    getSectionalTemplates();
  };

  const handleRemoveTemplateName = () => {
    setSelectedTemplate({
      name: "",
      id: "",
    });
  };

  const handleSelectedPastConsultation = (selected_data) => {
    setSelectedTemplate({ name: "", id: "" });
    setTemplateName({ name: "", id: "" });
    setIsChecked(false);
    setTemplateError(false);
    let index = pastConsultationsList.findIndex(
      (pastConsultation) =>
        pastConsultation.prescription_id === selected_data.prescription_id
    );
    pastConsultationsList.forEach((pastConsultation) => {
      if (pastConsultation.prescription_id !== selected_data.prescription_id) {
        pastConsultation.selected = false;
      }
    });
    if (!pastConsultationsList[index].selected) {
      pastConsultationsList[index].selected =
        !pastConsultationsList[index].selected;
    }
    handlePastConsultationSelection(selected_data);

    templatesList.forEach((template) => {
      template.selected = false;
    });
    setTemplatesList([...templatesList]);
    setPastConsultationsList([...pastConsultationsList]);
  };

  const toggleSaveSharedPrescription = () => {
    setHideShowShareSavedPrescription(!hideShowShareSavedPrescription);
  };

  const togglePastPrescription = () => {
    setHideShowPastPrescription(!hideShowPastPrescription);
  };

  const handleSelectRecord = (item) => {
    let ind = addRecordList.findIndex((ele) => ele.id === item.id);
    addRecordList[ind].selected = !addRecordList[ind].selected;
    let index = erxComponents.findIndex((comp) => comp.name === item.value);
    erxComponents[index].show = addRecordList[ind].selected;
    setAddRecordList([...addRecordList]);
    setErxComponents([...erxComponents]);
    updateSectionSettings();
  };

  const getPemSuggestedKey = () => {
    let keys = ["all"];
    diagnosisList.value.forEach((obj) => {
      if (obj.title !== "") {
        keys.push(obj.title);
      }
    });
    patient_history_and_complaints.value.forEach((obj) => {
      if (obj.value?.length > 0) {
        obj.value.forEach((ob) => {
          keys.push(ob.title);
        });
      }
    });
    let unique = [...new Set(keys)];
    return unique;
  };

  const handleDrugData = (
    call_api,
    data,
    addNewDrug = false,
    templateSelcetedForDrug
  ) => {
    setDrugList({
      call_api: call_api,
      value: data,
      updateState: addNewDrug,
      templateSelected: templateSelcetedForDrug
        ? templateSelcetedForDrug
        : false,
    });
  };

  const pemCloseBtnCallback = (closeBtnState = false) => {
    setShowPEMPopUp(false);
    if (!closeBtnState) {
      setShowPopUp(true);
    }
  };

  const closeSharedPopup = () => {
    setShowPrescriptionShareModal(false);
  };

  const saveDrugData = (medications, callAPI, templateSelcetedForDrug) => {
    let drugData = [...medications];

    if (drugData?.length > 0) {
      let arr = saveDrugDataHelper(drugData, prescription_id);
      handleDrugData(
        callAPI ? callAPI : false,
        arr,
        false,
        templateSelcetedForDrug
      );
    } else {
      handleDrugData(
        callAPI ? callAPI : false,
        [],
        false,
        templateSelcetedForDrug
      );
    }
  };

  const handleRedirectToErx = (ele) => {
    setShowPrescriptionHome(SELECTED_TAB_LIST.HOME);
    let item = redirectItem ?? ele;
    let ind = erxComponents.findIndex((comp) => comp.id === item.id);
    erxComponents[ind].expand = true;
    setErxComponents([...erxComponents]);
    updateSectionSettings();
    setTimeout(() => {
      let element = document.getElementById(item.name);
      element && element.scrollIntoView();
      if (item.hasInputs) {
        if (
          element?.tagName?.toLowerCase() === "input" ||
          element?.tagName?.toLowerCase() === "textarea"
        ) {
          element.focus();
        } else {
          let texteAreaElement =
            element?.getElementsByTagName("textarea")[0]?.offsetTop;
          let inputElement =
            element?.getElementsByTagName("input")[0]?.offsetTop;
          if (texteAreaElement && inputElement) {
            if (texteAreaElement < inputElement) {
              element.getElementsByTagName("textarea")[0].focus();
            } else {
              element.getElementsByTagName("input")[0].focus();
            }
          } else {
            if (texteAreaElement) {
              element.getElementsByTagName("textarea")[0].focus();
            } else if (inputElement) {
              element.getElementsByTagName("input")[0].focus();
            }
          }
        }
      }
      setRedirectItem(null);
    }, 10);
  };

  const handleCloseBackToErxPopup = () => {
    setOpenBackToErxPopup(false);
  };

  const handleRedirect = (item) => {
    if (showPrescriptionHome === SELECTED_TAB_LIST.GROWTH_CHART) {
      setOpenBackToErxPopup(true);
      setRedirectItem(item);
    } else {
      setRedirectItem(null);
      handleRedirectToErx(item);
    }
  };

  const handleDisablePreview = () => {
    setDisablePreview(false);
  };

  const handleClose = () => {
    toggleDrawer();
  };

  const handleGrowthChart = () => {
    setShowEditGrowthChart(true);
    fetchVitals();
  };

  const handleUpdateAPICall = () => {
    updatePrescriptionData("edited");
  };
  const getSectionalTemplates = () => {
    c2cGetApiHandler(
      `${GET_SECTION_TEMPLATE}?doctor_id=${user_id}&clinic_id=${
        clinicId ? clinicId : ""
      }`
    ).then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setSectionalTemplateList(res.data);
        }
      }
    });
  };

  const onSectionTempSave = (comp, name) => {
    const getTemplateId = () => {
      let id = "";
      if (
        sectionalTemplateList &&
        Object.keys(sectionalTemplateList).length > 0
      ) {
        Object.keys(sectionalTemplateList).forEach((key) => {
          if (comp.templateTitle === SECTIONAL_TEMPLATES.DIAGNOSIS_TEMPLATE) {
            // dont change spelling dignosis_template
            let found = sectionalTemplateList["dignosis_template"]?.find(
              (obj) => obj.template_name.toLowerCase() === name.toLowerCase()
            );
            if (found) {
              id = found.id;
            }
          }
          if (
            comp.templateTitle ===
            SECTIONAL_TEMPLATES.SUGGESTED_INVESTIGATION_TEMPLATE
          ) {
            let found = sectionalTemplateList[
              "suggested_investigation_template"
            ]?.find(
              (obj) => obj.template_name.toLowerCase() === name.toLowerCase()
            );
            if (found) {
              id = found.id;
            }
          }
          if (comp.templateTitle === SECTIONAL_TEMPLATES.DRUG_TEMPLATE) {
            let found = sectionalTemplateList["drug_templates"]?.find(
              (obj) => obj.template_name.toLowerCase() === name.toLowerCase()
            );
            if (found) {
              id = found.id;
            }
          }
        });
      }
      return id;
    };
    let data = [];
    let sectionName = "";
    if (
      comp.templateTitle ===
      SECTIONAL_TEMPLATES.SUGGESTED_INVESTIGATION_TEMPLATE
    ) {
      sectionName = "suggested_investigation";
      let SI = followUp?.value?.find(
        (ob) => ob?.name === "suggested_investigation"
      );
      data = SI;
    }
    if (comp.templateTitle === SECTIONAL_TEMPLATES.DRUG_TEMPLATE) {
      sectionName = "drug";
      data = drugList.value;
    }
    if (comp.templateTitle === SECTIONAL_TEMPLATES.DIAGNOSIS_TEMPLATE) {
      sectionName = "diagnosis";
      data = diagnosisList.value;
    }
    let payload = {
      section_name: sectionName,
      template_name: name,
      data: data,
      doctor_id: user_id,
      clinic_id: clinicId ? clinicId : null,
      id: getTemplateId(),
    };
    c2cPostApiHandler(CREATE_SECTION_TEMPLATE, payload).then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        if (res?.data?.message === "template is updated..!!!") {
          setAlertMesg(`Template ${name} is updated.`);
        } else {
          setAlertMesg(`You have saved your template: ${name}`);
        }
        setShowAlertPopup(true);
        setTimeout(() => {
          setShowAlertPopup(false);
          setAlertMesg("You have saved your template");
        }, 3000);
        setSelectedSectionTemp({
          ...selectedSectionTemp,
          [comp.templateTitle]: "",
        });
        getSectionalTemplates();
      }
    });
  };

  const onSectionTempDelete = (id, deletedComp) => {
    c2cDeleteApiHandler(`${DELETE_SECTION_TEMPLATE}/${id}`).then(
      ([res, err]) => {
        if (!err && res?.data?.statusCode === 200) {
          setSelectedSectionTemp({
            ...selectedSectionTemp,
            [deletedComp]: "",
          });
          getSectionalTemplates();
        }
      }
    );
  };

  const handleOpenPrintChartPopup = () => {
    setOpenPrintChartPopup(true);
  };

  const handleClosePrintChartPopup = () => {
    setOpenPrintChartPopup(false);
  };

  const handleYes = () => {
    setLoader(true);
    setOpenPrintChartPopup(false);
    let reqPayload = {
      prescription_id: prescription_id,
      appointment_id: appointmentData?.appointment_id,
      clinic_id: appointmentData?.clinic_id,
      doctor_id: appointmentData?.doctor_id,
    };
    const printGrowChartPDFResponse = c2cPostApiHandler(
      PRINT_GROW_CHART,
      reqPayload
    ); //Fetch API Data
    printGrowChartPDFResponse.then(([res, error]) => {
      if (!error && res?.data?.statusCode === 200) {
        setLoader(false);
        fetchVitals();
        setShowPrescriptionHome(SELECTED_TAB_LIST.HOME);
      }
    });
  };

  const handleNo = () => {
    setCallGrowthChartVitals(true);
    handleClosePrintChartPopup();
  };

  const handleClosePreview = () => {
    setShowPreviewModal(false);
  };

  const handleTemplateSave = () => {
    let templateExists = templatesList.filter(
      (template) =>
        template?.template_name?.toLowerCase()?.trim() ===
          templateName?.name?.toLowerCase()?.trim() &&
        template?.status === "saved"
    );
    if (templateExists.length !== 0) {
      setTemplateError(true);
    } else {
      setTemplateError(false);
      handleSaveTemplateAPICall(false);
    }
  };

  const handleTemplateCancel = () => {
    setTemplateName({ name: selectedTemplate?.name, id: selectedTemplate?.id });
    setTemplateError(false);
    setIsChecked(false);
    setSavePrescriptionTemplate(false);
  };

  const handleOverrideTemplateNo = () => {
    setTemplateError(false);
  };
  const handleOverrideTemplateYes = () => {
    handleSaveTemplateAPICall(true);
  };

  const handleOnChangeObstetricHistory = (item, val) => {
    let tempObstetricList = { ...obstetricHistoryList };
    let obstetricValue = [...tempObstetricList?.value];
    let ind = obstetricValue.findIndex((ele) => ele.id === item.id);
    if (item.type === "number") {
      let numericValue = val.target.value.replace(/\D/g, "").slice(0, 2);
      obstetricValue[ind].value = numericValue;
    } else if (item.type === "string") {
      let stringValue = val.target.value.slice(0, 250);
      obstetricValue[ind].value = stringValue;
    }
    setObstetricHistoryList({
      call_api: true,
      value: obstetricValue,
    });
    saveObstetricHistoryForMiniMap(obstetricValue);
  };

  const handleAddCustomSection = () => {
    let custom_section = { ...customSection?.value };
    let custom_length = Object.keys(custom_section).length;
    if (custom_length < 3) {
      let customSectionIds = [];
      erxComponents.forEach((data) => {
        if (data?.name?.includes("CustomSection") && !data?.show) {
          customSectionIds.push(data?.name);
        }
      });
      if (customSectionIds?.length > 0) {
        let customSectionKey = customSectionIds[0];
        let custom_index = erxComponents.findIndex(
          (ele) => ele.name === customSectionKey
        );
        if (custom_index > -1) {
          setCustomSection({
            ...customSection,
            call_api: true,
            value: {
              ...custom_section,
              [customSectionKey]: {
                custom_id: 1,
                custom_title: `Custom Section`, // ${custom_length + 1}
                fields: [
                  {
                    field_id: 1,
                    field_title: "Edit Field 01",
                    value: [],
                  },
                ],
              },
            },
          });
        }
        erxComponents[custom_index].title = `Custom Section`; // ${custom_length + 1}
        erxComponents[custom_index].show = true;
        erxComponents[custom_index].expand = true;
        let newData = erxComponents.splice(custom_index, 1);
        erxComponents.splice(erxComponents.length - 1, 0, newData[0]);
        erxComponents.forEach((data, index) => {
          data.position = index;
        });
        setErxComponents([...erxComponents]);
        updateSectionSettings();
      }
    }
  };

  const handleCustomSection = (callAPI, key, value) => {
    let tempCustomSection = {
      ...customSection.value,
    };
    tempCustomSection[key].fields = value;
    setCustomSection({
      ...customSection,
      call_api: callAPI,
      value: tempCustomSection,
    });
  };

  const handleEditLabel = (value, sectionName) => {
    let tempCustomSection = { ...customSection?.value };
    tempCustomSection[sectionName].custom_title = value;
    setCustomSection({
      ...customSection,
      call_api: true,
      value: tempCustomSection,
    });

    let tempErxCompenent = [...erxComponents];
    let erxIndex = tempErxCompenent.findIndex(
      (data) => data?.name === sectionName
    );
    tempErxCompenent[erxIndex].title = value;
    setErxComponents([...tempErxCompenent]);
  };

  const handleDeleteCustomSection = (customKey) => {
    let tempComponent = [...erxComponents];
    let tempIndex = tempComponent.findIndex((data) => data?.name === customKey);
    let tempCustomSection = { ...customSection?.value };
    delete tempCustomSection[customKey];

    if (tempIndex > -1) {
      tempComponent[tempIndex].show = false;
      tempComponent[tempIndex].title = "Custom Section";
    }
    setErxComponents([...tempComponent]);
    setCustomSection({
      call_api: true,
      value: tempCustomSection,
    });
  };

  const handleSetDefaultTemplate = (templateId) => {
    setDefaultTemplateId(templateId);
    let tempList = [...templatesList];
    tempList.forEach((data) => {
      data["is_default_template"] = "False";
    });
    let templateIndex = tempList?.findIndex(
      (template) => template?.template_id === templateId
    );
    if (templateIndex > -1) {
      tempList[templateIndex].is_default_template = "True";
    }
    setTemplatesList(tempList);
    updateSectionSettings(templateId);
  };

  // <===

  // Helper Methods ===>

  const handleAutoPopulate = (list, vaccineData) => {
    let vaccines = list?.filter(
      (ele) => ele.title?.toLowerCase() !== "general vaccines"
    );
    let generalVaccines = list?.filter(
      (ele) => ele.title?.toLowerCase() === "general vaccines"
    );

    vaccines.forEach((item) => {
      if (patientDob && !checkIfAgeAboveSixteen()) {
        if (item.title?.toLowerCase().includes("birth")) {
          item.vaccines.forEach((ele) => {
            ele.scheduled_date = ele.scheduled_date
              ? ele.scheduled_date
              : moment(new Date(patientDob))
                  .add("1", "d")
                  .format("DD MMM YYYY");
          });
        } else if (item.title?.toLowerCase().includes("weeks")) {
          item = getDueDates(item, "weeks", "w", patientDob);
        } else if (item.title?.toLowerCase().includes("months")) {
          item = getDueDates(item, "months", "M", patientDob);
        } else if (item.title?.toLowerCase().includes("years")) {
          item = getDueDates(item, "years", "Y", patientDob);
        }
      }
      item.vaccines.forEach((ele) => {
        ele.scheduled_date = ele.scheduled_date
          ? moment(new Date(ele.scheduled_date)).format("DD MMM YYYY")
          : "";
        ele.vaccinated_date = ele.vaccinated_date
          ? moment(new Date(ele.vaccinated_date)).format("DD MMM YYYY")
          : "";

        if (ele.vaccinated_date) {
          if (
            !ele.prescription_id ||
            (ele.prescription_id && ele.prescription_id === prescription_id)
          ) {
            ele.isEditable = true;
          } else {
            ele.isEditable = false;
          }
        } else {
          ele.isEditable = true;
        }
      });
      item.show = searchVaccine?.toLowerCase()
        ? item.vaccines.filter((ele) =>
            ele.name?.toLowerCase().includes(searchVaccine?.toLowerCase())
          )?.length !== 0
        : true;
      item.expand = !checkIfAgeAboveSixteen();
    });

    generalVaccines.forEach((item) => {
      item.show = searchVaccine?.toLowerCase()
        ? item.vaccines.filter((ele) =>
            ele.name?.toLowerCase().includes(searchVaccine?.toLowerCase())
          )?.length !== 0
        : true;
      item.expand = true;
      item.vaccines.forEach((ele) => {
        ele.scheduled_date = ele.scheduled_date
          ? moment(new Date(ele.scheduled_date)).format("DD MMM YYYY")
          : "";
        ele.vaccinated_date = ele.vaccinated_date
          ? moment(new Date(ele.vaccinated_date)).format("DD MMM YYYY")
          : "";

        if (ele.vaccinated_date) {
          if (
            !ele.prescription_id ||
            (ele.prescription_id && ele.prescription_id === prescription_id)
          ) {
            ele.isEditable = true;
          } else {
            ele.isEditable = false;
          }
        } else {
          ele.isEditable = true;
        }
      });
    });

    vaccines.forEach((ele) => {
      ele.vaccines.forEach((item) => {
        if (item.prescription_id === prescription_id && item.vaccinated_date) {
          item.height = vaccineData?.height ?? item.height;
          item.weight = vaccineData?.weight ?? item.weight;
          item.head_circumference =
            vaccineData?.head_circumference ?? item.head_circumference;
          item.height_unit = vaccineData?.height_unit ?? item.height_unit;
          item.weight_unit = vaccineData?.weight_unit ?? item.weight_unit;
          item.head_circumference_unit =
            vaccineData?.head_circumference_unit ??
            item.head_circumference_unit;
        }
      });
    });

    setVaccineList([...vaccines]);
    setGeneralVaccineList([...generalVaccines]);
  };

  const checkIfAgeAboveSixteen = () => {
    let value = "";
    if (patientDob) {
      let startDate = moment(patientDob, "YYYY-MM-DD");
      let endDate = moment();
      const duration = moment.duration(endDate.diff(startDate));
      value = duration.years() + duration.months() / 12 + duration.days() / 365;
    } else if (patientDetails?.patient_age) {
      value = patientDetails?.patient_age?.split("years")?.[0]?.trim();
    }

    setIsAgeAboveSixteen(+value > 16);
    return +value > 16;
  };

  const handleSelectedDays = (start, end) => {
    let result = end.diff(start, "days");
    let days = frequencyList
      .map((obj) => {
        return obj.value;
      })
      .includes(result);
    if (days) {
      setSelectedDays(result);
    } else {
      setSelectedDays("");
    }
  };

  const getTitle = () => {
    return (
      <span>
        Are you sure you want to go back to Erx? <br /> If yes then unsaved
        changes will be lost
      </span>
    );
  };

  const handleFiles = (files, e, key) => {
    let list = key === "docs" ? docList : fileList;
    for (const file of files) {
      let lastInd = file.name.lastIndexOf(".");
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const fileObject = {
          value: reader.result,
          name: file.name,
          size: (file.size / 1024 / 1024).toFixed(2),
          type: file.name.substring(lastInd + 1),
          fileName: file.name.substring(0, lastInd),
          fileType: file.type,
          id: uuid(),
          fileDate: file,
        };

        let filePath = fileObject.name;
        let allowedExtensions =
          /(\.jpg|\.jpeg|\.png|\.bmp|\.svg|\.doc|\.docx|\.pdf|\.txt|\.gif|\.xls|\.csv)$/i;
        if (!allowedExtensions.exec(filePath)) {
          alert(
            "The allowed extension is .jpeg/.jpg/.png/.gif/.svg/.bmp/.pdf/.doc/.xls/.csv/.docx only."
          );
        } else {
          list.push(fileObject);
          if (key === "docs") {
            setDocList([...list]);
          } else {
            setFileList([...list]);
          }
        }
      };
    }
    e.target.value = null;
  };

  const calcTotalFileSize = (files, e, key) => {
    let totalSize = 0;
    Object.keys(files).forEach((f) => {
      let fileSize = files[f].size / 1024 / 1024; //File Size in mb
      totalSize += fileSize;
    });
    fileList.forEach((file) => {
      let fileSize = file.size / 1024 / 1024; //File Size in mb
      totalSize += fileSize;
    });

    if (totalSize.toFixed(2) > 20) {
      swal({
        title: "File Size Exceeds Limit!",
        text: `Total File Size cannot be greater than 20 MB`,
        icon: "error",
      });
    } else {
      handleFiles(files, e, key);
    }
  };

  const handleAllPrescriptionData = (
    res,
    isShared,
    useMedications,
    callAPI,
    templateSelceted,
    templateSelcetedForDrug
  ) => {
    let responseData = res?.data?.prescription_data;
    if (responseData?.textual) {
      if (useMedications === "use_medications") {
        saveDrugData(
          responseData?.textual?.medications,
          callAPI,
          templateSelcetedForDrug
        );
      } else {
        getGetDrugsDataAPI(
          prescription_id
            ? prescription_id
            : responseData?.textual?.prescription_id,
          callAPI
        );
      }

      if (responseData?.textual?.doctor_specialization) {
        setDoctorSpecialization(responseData?.textual?.doctor_specialization);
      }
      if (responseData?.textual?.chief_complaints) {
        saveHistoryAndComplaints(
          "chief_complaints",
          responseData?.textual?.chief_complaints,
          callAPI
        );
      } else {
        saveHistoryAndComplaints("chief_complaints", [], callAPI);
      }
      if (responseData?.textual?.past_medical_history) {
        saveHistoryAndComplaints(
          "past_medical_history",
          responseData?.textual?.past_medical_history,
          callAPI
        );
      } else {
        saveHistoryAndComplaints("past_medical_history", [], callAPI);
      }
      if (responseData?.textual?.family_history) {
        saveHistoryAndComplaints(
          "family_history",
          responseData?.textual?.family_history,
          callAPI
        );
      } else {
        saveHistoryAndComplaints("family_history", [], callAPI);
      }
      if (responseData?.textual?.menstrual_history) {
        saveHistoryAndComplaints(
          "menstrual_history",
          responseData?.textual?.menstrual_history,
          callAPI
        );
      } else {
        saveHistoryAndComplaints("menstrual_history", [], callAPI);
      }
      if (responseData?.textual?.lifestyle_history) {
        saveHistoryAndComplaints(
          "lifestyle_history",
          responseData?.textual?.lifestyle_history,
          callAPI
        );
      } else {
        saveHistoryAndComplaints("lifestyle_history", [], callAPI);
      }
      if (responseData?.textual?.doctor_diagnosis) {
        if (responseData?.textual?.doctor_diagnosis?.length > 0) {
          responseData.textual.doctor_diagnosis.map((data, index) => {
            data["value"] = {
              id: data.id ? data.id : index,
              label: data?.title,
              value: data?.title,
            };
          });
          handleDiagnosis(
            callAPI ? callAPI : false,
            responseData?.textual?.doctor_diagnosis
          );
        } else {
          let def = [{ title: "", description: "", value: { id: 1 }, id: 1 }];
          handleDiagnosis(callAPI ? callAPI : false, def);
        }
      } else {
        handleDiagnosis(callAPI ? callAPI : false, [
          { title: "", description: "", value: { id: 1 }, id: 1 },
        ]);
      }
      if (responseData?.textual?.examinations) {
        if (responseData?.textual?.examinations?.length > 0) {
          responseData.textual.examinations.map((data, index) => {
            data["value"] = {
              id: data.id ? data.id : index,
              label: data?.title,
              value: data?.title,
            };
          });
          handleReport(
            callAPI ? callAPI : false,
            responseData?.textual?.examinations
          );
        } else {
          let def = [{ title: "", description: "", value: { id: 1 }, id: 1 }];
          handleReport(callAPI ? callAPI : false, def);
        }
      } else {
        handleReport(callAPI ? callAPI : false, [
          { title: "", description: "", value: { id: 1 }, id: 1 },
        ]);
      }
      if (responseData?.textual?.follow_up_date) {
        setFollowUpDate({
          call_api: callAPI ? callAPI : false,
          value: moment(responseData?.textual?.follow_up_date).format(
            "DD MMM YYYY"
          ),
        });
        let start = moment(appointmentData?.appointment_date);
        let end = moment(responseData?.textual?.follow_up_date);
        handleSelectedDays(start, end);
      } else {
        setFollowUpDate({ call_api: callAPI ? callAPI : false, value: "" });
        setSelectedDays("");
      }
      if (responseData?.textual?.doctor_notes) {
        setDoctorNote({
          call_api: callAPI ? callAPI : false,
          value: responseData?.textual?.doctor_notes,
        });
      } else {
        setDoctorNote({ call_api: callAPI ? callAPI : false, value: "" });
      }
      if (responseData?.textual?.suggested_investigations_description) {
        let duplicatedFollowUp = [...followUp?.value];
        duplicatedFollowUp.forEach((obj) => {
          if (obj.name === "instructions_and_notes") {
            let suggested_description = [
              ...responseData?.textual?.suggested_investigations_description,
            ];
            if (suggested_description?.length > 0) {
              suggested_description.forEach((data, index) => {
                if (!data?.value) {
                  data["id"] = data.id ? data.id : index;
                  data["value"] = data?.title;
                  data["label"] = data?.label ?? "";
                }
                if (data?.master_id || data?.knowledge_base_id) {
                  data["button_status"] = "";
                } else {
                  data["button_status"] = CUSTOM_BUTTON_STATUS.SAVE;
                }
              });
            }
            obj.value = suggested_description;
          }
        });
        setFollowUp({
          call_api: callAPI ? callAPI : false,
          value: JSON.parse(JSON.stringify(duplicatedFollowUp)),
        });
      } else {
        setFollowUp({
          call_api: callAPI ? callAPI : false,
          value: JSON.parse(JSON.stringify(FOLLOW_UP_LIST)),
        });
      }
      if (responseData?.textual?.suggested_investigations_extended) {
        let duplicatedFollowUp = [...followUp?.value];
        duplicatedFollowUp.forEach((obj) => {
          if (obj.name === "suggested_investigation") {
            let suggested_extended = [
              ...responseData?.textual?.suggested_investigations_extended,
            ];
            if (suggested_extended?.length > 0) {
              suggested_extended.forEach((data, index) => {
                if (!data?.value) {
                  data["id"] = data.id ? data.id : index;
                  data["value"] = data?.title;
                  data["label"] = data?.label ?? "";
                }
              });
            }
            obj.value = suggested_extended;
          }
        });
        setFollowUp({
          call_api: callAPI ? callAPI : false,
          value: JSON.parse(JSON.stringify(duplicatedFollowUp)),
        });
      } else {
        setFollowUp({
          call_api: callAPI ? callAPI : false,
          value: JSON.parse(JSON.stringify(FOLLOW_UP_LIST)),
        });
      }

      let vaccinationChartParams = {
        is_shared: false,
        template_selected: true,
      };

      getVaccineChartAPI(
        responseData?.textual?.prescription_id,
        templateSelceted ? vaccinationChartParams : isShared,
        callAPI,
        templateSelceted
      );

      if (responseData?.textual?.obstetric_history) {
        let obstetricValue = { ...responseData?.textual?.obstetric_history };
        saveObstetricHistory(obstetricValue);
      } else {
        setObstetricHistoryList({
          ...JSON.parse(JSON.stringify(OBSTETRIC_HISTORY_INPUTS)),
        });
      }

      if (responseData?.textual?.obstetric_details) {
        saveObstetricDetails(responseData?.textual?.obstetric_details, false);
      } else {
        if (!templateSelceted) {
          setObstetricDetails({
            ...JSON.parse(JSON.stringify(DEFAULT_OBSTETRIC_DETAILS)),
          });
        }
      }

      if (responseData?.textual?.custom_sections) {
        saveCustomSectionData(responseData?.textual?.custom_sections, callAPI);
      } else {
        saveCustomSectionData([], callAPI);
      }
    }
  };

  const saveSuggestionList = (data) => {
    if (data?.length > 0) {
      data.forEach((element) => {
        element["selected"] = false;
      });
      return data;
    }
    return [];
  };

  const handleApiLoaders = (api, loaderState) => {
    let ind = apiLoaders.findIndex((ele) => ele.api === api);
    apiLoaders[ind].loader = loaderState;
    setApiLoaders([...apiLoaders]);

    if (!loaderState && isPreviewClicked) {
      setTimeout(() => {
        setShowPreviewModal(true);
        setIsPreviewClicked(false);
      }, 10);
    }
  };

  // <===

  // Api Calls ===>

  const getVaccines = () => {
    let payload = {
      appointment_id: appointmentData?.appointment_id,
      prescription_id: prescription_id,
    };
    let resData = c2cPostApiHandler(GET_ALL_VACCINES, payload);
    resData.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        getVitalsForVaccines(res.data.data);
      } else {
        setLoader(false);
        handleApiLoaders("vitals", false);
      }
    });
  };

  const getVitalsForVaccines = (data) => {
    let payload = {
      appointment_id: appointmentData?.appointment_id,
      pediatric: true,
    };
    let resData = c2cPostApiHandler(GET_PATIENT_VITALS, payload);
    resData.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        if (res.data.data?.length !== 0) {
          setVaccineVitalsList(res.data.data[0]);
          handleAutoPopulate(data, res.data.data[0]);
          setLoader(false);
        } else {
          setVaccineVitalsList({});
          handleAutoPopulate(data, {});
          setLoader(false);
        }
        handleApiLoaders("vitals", false);
      } else {
        setVaccineVitalsList({});
        handleAutoPopulate(data, {});
        setLoader(false);
        handleApiLoaders("vitals", false);
      }
    });
  };

  const updateFollowUpDate = (id, date) => {
    let payload = {
      id: id,
      follow_up_date: date,
      prescription: true,
      enable_follow_up: enableLeadsDashboard,
    };
    handleApiLoaders("followUp", true);

    c2cPostApiHandler(ADD_FOLLOWUP_DATE, payload).then(([res, err]) => {
      if (!err) {
        handleApiLoaders("followUp", false);
      }
    });
  };
  const getCreatePrescription = (template_id) => {
    let reqPayload = {
      "authorizer-principal-id": {
        user_type: user_type === APPLICABLE_ROLE.STAFF ? "4" : "1",
        user_id: user_type === APPLICABLE_ROLE.STAFF ? staff_id : user_id,
      },
      appointment_id: appointmentData?.appointment_id,
      prescription_status: "created",
    };
    c2cPostApiHandler(GET_PRESCRIPTION_ID, reqPayload).then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode === 200) {
          setCreatedPrescriptionId(res?.data?.data?.prescription_id);
          setPrescriptionId(res?.data?.data?.prescription_id);
          setDoctorSpecialization(res?.data?.data?.doctor_specialization);
          if (
            !res?.data?.data?.obstetric_details ||
            moment(
              new Date(res?.data?.data?.obstetric_details?.edd_date),
              "YYYY/MM/DD"
            )
              .hours(0)
              .minutes(0)
              .seconds(0)
              .milliseconds(0)
              .isBefore(moment().hours(0).minutes(0).seconds(0).milliseconds(0))
          ) {
            setObstetricDetails({
              ...JSON.parse(JSON.stringify(DEFAULT_OBSTETRIC_DETAILS)),
              callObstetricDetailsApi: true,
            });
          } else {
            saveObstetricDetails(res?.data?.data?.obstetric_details, true);
          }
          getGetDrugsDataAPI(
            prescription_id ? prescription_id : res?.data?.data?.prescription_id
          );

          let vaccinationChartParams = {
            is_shared: false,
            template_selected: false,
          };
          getVaccineChartAPI(
            res?.data?.data?.prescription_id,
            vaccinationChartParams,
            ""
          );
          if (template_id) {
            setIsTemplateSelected(true);
            getDefaultTemplateData(template_id);
          } else {
            setLoader(false);
          }
        }
      }
    });
  };

  const getPatientDetailsApi = () => {
    let reqPayload = {
      "authorizer-principal-id": {
        user_type: user_type === APPLICABLE_ROLE.STAFF ? "4" : "1",
      },
      appointment_id: appointmentData?.appointment_id,
    };
    const resData = c2cPostApiHandler(GET_PATIENT_DETAILS, reqPayload);
    resData.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setPatientDetails(res.data.data);
          setUpdatedGender(res.data.data?.patient_gender);
          let payload = {};
          vitalsList.forEach((obj) => {
            payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}`] =
              obj.value;
            payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}_unit`] =
              obj.unit;
          });
          setEditedPayload({ ...editedPayload, ...payload });
          setPatientPhoneNo(res.data.data?.patient_phone_no);
          setPatientDetailsName(res.data.data?.patient_name);
          genderOptions.forEach(
            (opt) =>
              (opt.selected =
                opt.label.toLowerCase() ===
                res.data.data?.patient_gender.toLowerCase())
          );
          setGenderOptions([...genderOptions]);
          const age = getAgeInYearsMonthDays(
            res.data.data?.patient_dob,
            res.data.data?.patient_age
          );
          setPatientAge(age);
        } else {
          setPatientDetails({});
        }
      } else {
        setPatientDetails({});
      }
    });
  };

  const saveVitals = () => {
    let filteredLmp = { ...addEditVitals?.value };
    handleApiLoaders("vitals", true);
    c2cPostApiHandler(ADD_EDIT_VITALS, filteredLmp).then(([res, error]) => {
      C2CConsole.log(res);
      getVaccines();
    });
  };

  const fetchVitals = () => {
    let payload = {
      appointment_id: appointmentData?.appointment_id,
    };
    c2cPostApiHandler(GET_PATIENT_VITALS, payload).then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setVitalsForPrefill(res?.data?.data);
          setAddEditVitals({ call_api: false, value: res?.data?.data[0] });
        }
      }
    });
  };

  const processTemplateData = (res, error) => {
    setLoader(false);
    if (!error && res.data?.statusCode === 200) {
      let isShared = res.data.prescription_data?.textual?.is_shared;
      let responseData = res.data.prescription_data?.textual;
      responseData["past_medical_history"] = [];
      responseData["lifestyle_history"] = [];
      responseData["menstrual_history"] = [];
      responseData["family_history"] = [];
      responseData["doctor_notes"] = "";
      responseData["follow_up_date"] = "";
      res.data.prescription_data.textual = {
        ...res.data.prescription_data.textual,
        ...responseData,
      };
      handleAllPrescriptionData(
        res,
        isShared,
        "use_medications",
        true,
        true,
        true //passing true for template selected for drug
      );
    }
  };

  const handleTemplateSelection = (item) => {
    setLoader(true);
    setTemplateError(false);
    setIsChecked(false);
    setTemplateName({ name: item?.template_name, id: item?.template_id ?? "" });
    setIsTemplateSelected(true);
    let payload = {
      ...(item.template_id
        ? { template_id: item?.template_id }
        : {
            prescription_id: item.prescription_id,
            appointment_id: item?.appointment_id,
            status: item?.status,
          }),
      template_name: item.template_name,
    };

    c2cPostApiHandler(GET_ERX_TEMPLATE_DATA, payload).then(([res, error]) => {
      processTemplateData(res, error);
    });
  };

  const handlePastConsultationSelection = (item) => {
    setLoader(true);
    setIsTemplateSelected(true);
    let payload = {
      appointment_id: item.appointment_id,
      prescription_id: item.prescription_id,
      saved: item.prescription_type,
    };
    c2cPostApiHandler(GET_PREVIOUS_PRESCRIPTION, payload).then(
      ([res, error]) => {
        setLoader(false);
        if (!error) {
          if (res?.data?.statusCode === 200) {
            let isShared = res?.data?.prescription_data?.textual?.is_shared;
            handleAllPrescriptionData(
              res,
              isShared,
              "use_medications",
              true,
              false,
              true //passing template seleced true for drug
            );
          }
        }
      }
    );
  };

  const handleDefaultAlertMessage = () => {
    setTimeout(() => {
      setAlertMessage({
        show: false,
        title: "",
        content: "",
        type: "",
      });
    }, 2000);
  };

  //Handle followUp date through scheduled followup
  const scheduleFollowUp = async () => {
    const { res } = await viewFollowUpDate(appointmentData?.appointment_id);
    if (res) {
      let data = {
        call_api: res.FollowUp_Date ? true : false,
        value:
          res.FollowUp_Date.toLowerCase() === "none" || !res.FollowUp_Date
            ? ""
            : moment(res.FollowUp_Date).format("DD MMM YYYY"),
      };
      setFollowUpDate(data);
      if (data?.value) {
        let start = moment(appointmentData?.appointment_date);
        let end = moment(data?.value);
        handleSelectedDays(start, end);
      } else {
        setSelectedDays("");
      }
    }
  };

  const getPrescriptionAPICall = () => {
    if (appointmentData?.prescription_id === "") {
      getCreatePrescription();
    } else {
      let params = {
        appointment_id: appointmentData?.appointment_id,
      };
      c2cPostApiHandler(GET_PRESCRIPTION_DATA, params).then(([res, error]) => {
        setLoader(false);
        if (!error) {
          if (res?.data?.statusCode === 200) {
            let responseData = res?.data?.prescription_data;
            setPrescriptionId(responseData?.textual?.prescription_id);
            setPatientPhoneNo(responseData?.textual?.patient_phone_no);
            handleAllPrescriptionData(res, false, "", false, false);
          }
        }
      });
    }
  };

  const getDoctorsPastNotes = (id, page_no, reset = false) => {
    let params = {
      page_no: page_no,
    };
    getDoctorNotes(id, params).then(([res, count, err]) => {
      if (!err) {
        let max = Math.ceil(count / 5);
        setMaxApiCallForNotes(max);
        reset
          ? setDoctorsPastNotes([...res])
          : setDoctorsPastNotes([...doctorsPastNotes, ...res]);
      }
    });
  };

  const updateShareErxWithPharmacy = () => {
    const payload = {
      data: pharmacyList
        .filter((pharmacy) => pharmacy?.selected)
        .map((pharmacy) => ({
          pharmacy_id: pharmacy?.pharmacy_id,
          appointment_id: appointmentData?.appointment_id,
          documents: [
            {
              id: documentDetils.documentID,
              prescription_type: documentDetils.erxType,
            },
          ],
        })),
    };
    c2cPostApiHandler(SHARE_RX_WITH_PHARMACY, payload).then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setAlertMessage({
            show: true,
            title: "",
            content: {
              __html: `Patient’s prescription has been shared successfully with the pharmacy`,
            },
            type: "success",
          });
          handleDefaultAlertMessage();
        } else {
          setAlertMessage({
            show: false,
            title: "",
            content: {
              __html: "",
            },
            type: "success",
          });
        }
      }
    });
  };

  const updateSharePharmacySettings = () => {
    let payload = {
      user_id: appointmentData?.doctor_id,
      clinic_id: clinicId ? clinicId : user_id,
      section_type: "SharedPharmacy",
      filter_options: pharmacyList,
      sort_options: {},
    };
    handleApiLoaders("userSettings", true);
    c2cPostApiHandler(UPDATE_USER_SETTINGS, payload).then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          handleApiLoaders("userSettings", false);
          getTemplatesApi();
        } else {
          handleApiLoaders("userSettings", false);
        }
      } else {
        handleApiLoaders("userSettings", false);
      }
    });
  };

  const getPharmacyList = () => {
    c2cGetApiHandler(GET_PHARMACY_LIST(clinicId)).then(([res, error]) => {
      if (res?.data?.statusCode === 200) {
        const transformedData = res?.data?.data?.map((item) => ({
          pharmacy_id: item.pharmacy_id,
          name: item.name,
          selected: false,
        }));
        setPharmacyList(transformedData);
        setDefaultPharmacy(res?.data?.default_pharma);
        if (transformedData.length > 0) {
          getPharmacySectionSettings();
        }
      } else {
        setPharmacyList([]);
      }
    });
  };

  const getPharmacySectionSettings = () => {
    c2cGetApiHandler(
      GET_USER_SETTINGS +
        `?section_type=SharedPharmacy&clinic_id=${
          clinicId ? clinicId : user_id
        }&user_id=${appointmentData?.doctor_id}`
    ).then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          let filterdata = res?.data?.data[0]?.filter_options;
          setSelectedPharmacyList([...filterdata]);
        } else {
          setSelectedPharmacyList([]);
        }
      }
    });
  };

  const saveHistoryAndComplaints = (key, prescription_data, callAPI) => {
    let dataValue = [...patient_history_and_complaints?.value];
    let index = dataValue.findIndex((val) => val.name === key);
    let finalData = prescription_data;
    finalData.map((data, filterIndex) => {
      data["id"] = data.id ? data.id : filterIndex;
      data["label"] = data.title;
      data["value"] = data.title;
      if (data?.master_id || data?.knowledge_base_id) {
        data["button_status"] = "";
      } else {
        data["button_status"] = CUSTOM_BUTTON_STATUS.SAVE;
      }
      if (data?.painScaleData) {
        data["painScaleData"]["selected_option"] = {
          label: data["painScaleData"]?.pain_scale,
          value: data["painScaleData"]?.pain_scale,
        };
      }
    });
    dataValue[index].value = finalData;
    setPatientHistoryAndComplaints({
      call_api: false,
      value: JSON.parse(JSON.stringify(dataValue)),
    });
  };

  const saveObstetricDetails = (
    obstetricDetailsData,
    callObstetricDetailsApi
  ) => {
    let diffDays = null;

    if (obstetricDetailsData?.lmp_date) {
      const date1 = new Date(obstetricDetailsData?.lmp_date);
      const date2 = new Date();
      const diffTime = Math.abs(date2 - date1);
      diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    }
    let cycleLength =
      obstetricDetailsData?.cycle_length ??
      DEFAULT_OBSTETRIC_DETAILS?.cycleLength;
    let cycleLengthValue =
      DEFAULT_OBSTETRIC_DETAILS?.cycleLength - +cycleLength;

    let egaWeeks = obstetricDetailsData?.lmp_date
        ? parseInt((diffDays + cycleLengthValue) / 7)
        : DEFAULT_OBSTETRIC_DETAILS?.egaWeeks,
      egaDays = obstetricDetailsData?.lmp_date
        ? (diffDays + cycleLengthValue) % 7
        : DEFAULT_OBSTETRIC_DETAILS?.egaDays;

    let data = {
      lmpDate:
        obstetricDetailsData?.lmp_date ?? DEFAULT_OBSTETRIC_DETAILS?.lmpDate,
      eddDate:
        obstetricDetailsData?.edd_date ?? DEFAULT_OBSTETRIC_DETAILS?.eddDate,
      cycleLength: cycleLength,
      egaWeeks: egaWeeks > 0 ? egaWeeks : 0,
      egaDays: egaDays > 0 ? egaDays : 0,
      note: obstetricDetailsData?.note ?? DEFAULT_OBSTETRIC_DETAILS?.note,
      callObstetricDetailsApi: callObstetricDetailsApi,
    };

    setObstetricDetails({ ...data });
  };

  const saveObstetricHistory = (obstetricValue) => {
    let tempObstetricHistoryList = [...obstetricHistoryList?.value];
    if (
      typeof obstetricValue === "object" &&
      Object.keys(obstetricValue).length > 0
    ) {
      for (const [key, value] of Object.entries(obstetricValue)) {
        let obstetricIndex = tempObstetricHistoryList.findIndex(
          (obstric) => obstric.label === key
        );
        if (obstetricIndex > -1) {
          tempObstetricHistoryList[obstetricIndex].value = value;
        }
      }
      setObstetricHistoryList({
        call_api: false,
        value: tempObstetricHistoryList,
      });
      saveObstetricHistoryForMiniMap(tempObstetricHistoryList);
    } else {
      tempObstetricHistoryList.forEach((obstetric_value) => {
        obstetric_value.value = "";
      });
      setObstetricHistoryList({
        call_api: false,
        value: tempObstetricHistoryList,
      });
      saveObstetricHistoryForMiniMap(tempObstetricHistoryList);
    }
  };

  const saveObstetricHistoryForMiniMap = (obstetricList) => {
    let temp_patient_history_and_complaints = [
      ...patient_history_and_complaints?.value,
    ];
    let obstetricIndex = temp_patient_history_and_complaints?.findIndex(
      (list) => list?.name === "obstetric_history"
    );
    if (obstetricIndex > -1) {
      temp_patient_history_and_complaints[obstetricIndex].value = [
        ...obstetricList,
      ];
      setPatientHistoryAndComplaints({
        call_api: false,
        value: temp_patient_history_and_complaints,
      });
    }
  };

  const updatePrescriptionData = (status) => {
    let settings = {
      includeInErx: {},
      hidePastVitals: {},
    };
    let hidObj = {};
    let tempObj = {};
    erxComponents.map((ob) => {
      if (ob.settings) {
        ob.settings.map((o) => {
          if (o["que_key"] === "includeInErx") {
            tempObj[ob.name] = o.answer;
          }
          if (o["que_key"] === "hidePastVitals") {
            hidObj[ob.name] = o.answer;
          }
        });
      }
    });
    settings["includeInErx"] = { ...tempObj };
    settings["hidePastVitals"] = { ...hidObj };

    let filterEmptyDiagnosis =
      diagnosisList?.value?.length > 0 &&
      diagnosisList?.value.filter(
        (obj) => obj.title || obj.value || obj.description
      );
    let filterEmptyReports =
      reportList?.value?.length > 0 &&
      reportList?.value.filter(
        (obj) => obj.title || obj.value || obj.description
      );
    let filteredLmp = { ...addEditVitals?.value };
    setIncludeErx({ ...settings?.includeInErx });
    let defaultRxKey = {
      DrugMedicine: true,
      "PatientFollow-up": true,
      PatientHistory: true,
      VaccineChart: true,
    };
    let reqPayload = {
      ...filteredLmp,
      hidePastVitals: settings?.hidePastVitals,
      includeInErx: { ...settings?.includeInErx, ...defaultRxKey },
      prescription_id: prescription_id,
      appointment_id: appointmentData?.appointment_id,
      doctor_diagnosis: filterEmptyDiagnosis ? filterEmptyDiagnosis : [],
      examinations: filterEmptyReports ? filterEmptyReports : [],
      medication: status !== "edited" && [...drugList?.value],
      suggested_investigations_extended: getSuggestedInvestigationPayload(
        "suggested_investigation",
        followUp?.value
      ),
      suggested_investigations_description: getInstructionAndNotesPayload(
        "instructions_and_notes",
        followUp?.value
      ),
      doctor_notes: doctorNote?.value,
      chief_complaints: getHistoryAndComplaintPayload(
        "chief_complaints",
        patient_history_and_complaints?.value
      ),
      past_medical_history: getHistoryAndComplaintPayload(
        "past_medical_history",
        patient_history_and_complaints?.value
      ),
      menstrual_history: getHistoryAndComplaintPayload(
        "menstrual_history",
        patient_history_and_complaints?.value
      ),
      lifestyle_history: getHistoryAndComplaintPayload(
        "lifestyle_history",
        patient_history_and_complaints?.value
      ),
      family_history: getHistoryAndComplaintPayload(
        "family_history",
        patient_history_and_complaints?.value
      ),
      obstetric_history: getObstetricHistoryPayload(obstetricHistoryList),
      vaccine_notes: vaccineNotes?.value,
      custom_sections: getCustomSectionsValue(customSection?.value),
      obstetric_details: getObstetricDetails(),
    };
    let api =
      status === "edited"
        ? ADD_UPDATE_HISTORY_AND_COMPLAINTS + "/" + prescription_id
        : ADD_EDIT_PRESCRIPTION;
    reqPayload["prescription_status"] = status;
    reqPayload["share_prescription"] = status !== "edited";
    let method = status === "edited" ? "put" : "post";
    handleApiLoaders("updatePrescription", true);
    const addUpdateHistoryResponse = addUpdatePrescriptionData(
      reqPayload,
      api,
      method
    ); //Fetch API Data
    addUpdateHistoryResponse.then(([res, error]) => {
      setLoader(false);
      handleApiLoaders("updatePrescription", false);
    });
  };

  const handleSaveAndPreview = () => {
    setIsPreviewClicked(true);
    setTimeout(() => {
      if (!previewLoaderRef.current) {
        setShowPreviewModal(true);
        setIsPreviewClicked(false);
      }
    }, 600);
  };

  const callAllAPI = () => {
    getTemplatesApi();
    getPastConsultationsApi();
  };

  const handleEditCall = (id) => {
    id["appointment_id"] = appointmentData?.appointment_id;
    id["saved"] = true; //  saved:true ===> saved presc.
    c2cPostApiHandler(GET_PREVIOUS_PRESCRIPTION, id).then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          handleAllPrescriptionData(res, false, "", false, false);
        }
      }
    });
    fetchVitals(); // prefill-vitals
  };

  const getTemplatesApi = () => {
    let reqPayload = {
      doctor_id: user_id,
      clinic_id: clinicId ?? user_id,
    };
    const resData = c2cPostApiHandler(GET_SAVED_TEMPLATES, reqPayload);
    resData.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          let savedTemplate = res?.data?.all_saved_templates
            ? res?.data?.all_saved_templates
            : [];

          setTemplatesList([...savedTemplate]);
        } else {
          setTemplatesList([]);
        }
      } else {
        setTemplatesList([]);
      }
    });
  };

  const getPastConsultationsApi = () => {
    let reqPayload = appointmentData?.patient_id
      ? {
          doctor_id: appointmentData?.doctor_id,
          patient_id: appointmentData?.patient_id,
          patient_account_id: appointmentData?.patient_account_id,
          patient_dob: appointmentData?.patient_dob,
          patient_name: appointmentData?.patient_name,
          patient_phone_no: appointmentData?.patient_phone_no,
          appointment_id: appointmentData?.appointment_id,
        }
      : {
          doctor_id: appointmentData?.doctor_id,
        };
    const resData = c2cPostApiHandler(GET_PAST_CONSULTATIONS, reqPayload);
    resData.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          if (
            res?.data?.past_appointments ||
            res?.data?.past_saved_appointments
          ) {
            res?.data?.past_appointments &&
              res.data.past_appointments.forEach((appts) => {
                appts["prescription_type"] = "shared"; // adding shared key
              });
            res?.data?.past_saved_appointments &&
              res.data.past_saved_appointments.forEach((appts) => {
                appts["prescription_type"] = "saved"; // adding saved key
              });
            let all_past_appts = [];
            if (res?.data?.past_appointments) {
              all_past_appts = [
                ...all_past_appts,
                ...res.data.past_appointments,
              ];
            }
            if (res?.data?.past_saved_appointments) {
              all_past_appts = [
                ...all_past_appts,
                ...res.data.past_saved_appointments,
              ];
            }
            all_past_appts.sort((a, b) => {
              return (
                new Date(b.appointment_date) - new Date(a.appointment_date)
              );
            });
            setPastConsultationsList([...all_past_appts]);
          } else {
            setPastConsultationsList([]);
          }
        } else {
          setPastConsultationsList([]);
        }
      }
    });
  };

  const getSectionSettings = () => {
    c2cGetApiHandler(
      GET_USER_SETTINGS +
        `?section_type=ePrescriptions&clinic_id=${
          clinicId ? clinicId : user_id
        }&user_id=${appointmentData?.doctor_id}`
    ).then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          if (Object.keys(res?.data?.data[0]?.filter_options).length !== 0) {
            let data = res?.data?.data[0]?.filter_options;
            let sort_options = res?.data?.data[0]?.sort_options;
            let settingPdf = {};
            addRecordList.forEach((ele) => {
              ele.selected = data[ele.value]?.selection ?? true;
            });
            erxComponents.forEach((ele) => {
              if (ele.name === SELECTION_LIST_TITLES.VACCINE_CHART) {
                ele.expand = false;
              } else {
                ele.expand =
                  data[ele.name]?.expand !== undefined
                    ? data[ele.name]?.expand
                    : false;
              }

              if (
                ele.name === SELECTION_LIST_TITLES.MANUAL_PRESCRIPTION ||
                ele.name === SELECTION_LIST_TITLES.SAVED_SHARED_ERX ||
                ele.name === SELECTION_LIST_TITLES.PATIENT_DETAILS ||
                ele.name === SELECTION_LIST_TITLES.PATIENT_FOLLOW_UP
              ) {
                ele.show = true;
              } else if (
                ele.name === SELECTION_LIST_TITLES.CUSTOM_SECTION1 ||
                ele.name === SELECTION_LIST_TITLES.CUSTOM_SECTION2 ||
                ele.name === SELECTION_LIST_TITLES.CUSTOM_SECTION3
              ) {
                ele.show = false;
              } else {
                ele.show =
                  data[ele.name]?.selection !== undefined
                    ? data[ele.name]?.selection
                    : true;
              }

              if (ele?.settings) {
                ele.settings.map((o) => {
                  if (
                    data[ele.name] &&
                    data[ele.name][o.que_key] !== undefined
                  ) {
                    o.answer = data[ele.name][o.que_key];
                    if (
                      ele.name === SELECTION_LIST_TITLES.VITALS &&
                      o.que_key === "hidePastVitals"
                    ) {
                      setPastVitalsSetting(data[ele.name][o.que_key]);
                      o.answer = data[ele.name][o.que_key];
                    } else if (
                      ele.name === SELECTION_LIST_TITLES.VITALS &&
                      o.que_key === "includeInErx"
                    ) {
                      settingPdf[ele.name] = data[ele.name][o.que_key];
                      o.answer = data[ele.name][o.que_key];
                    } else {
                      settingPdf[ele.name] = data[ele.name][o.que_key];
                      o.answer = data[ele.name][o.que_key];
                    }
                  }
                });
              }
              if (
                ele.name !== SELECTION_LIST_TITLES.MANUAL_PRESCRIPTION &&
                ele.name !== SELECTION_LIST_TITLES.SAVED_SHARED_ERX &&
                ele.name !== SELECTION_LIST_TITLES.PATIENT_DETAILS &&
                ele.name !== SELECTION_LIST_TITLES.GROWTH_CHART &&
                sort_options
              ) {
                ele.position = sort_options[ele.name] ?? ele.position;
              }
            });
            erxComponents.sort((a, b) => (a.position > b.position ? 1 : -1));
            const updatedAddRecordList = addRecordList.map((ele) => {
              return {
                ...ele,
                item: ele.item ?? true,
              };
            });

            setAddRecordList([...updatedAddRecordList]);

            setIncludeErx({ ...settingPdf });
          }
          setDefaultTemplateId(
            res?.data?.data[0]?.default_erx_template_id ?? ""
          );
          if (
            !appointmentData?.prescription_status &&
            res?.data?.data[0]?.default_erx_template_id
          ) {
            getCreatePrescription(res?.data?.data[0]?.default_erx_template_id);
          } else {
            getPrescriptionAPICall();
          }
        }
      }
    });
  };

  const updateSectionSettings = (templateId) => {
    let options = {};
    let sort_options = {};
    erxComponents.forEach((ele) => {
      let setting = {};
      if (ele?.settings && ele?.settings?.length !== 0) {
        ele.settings.forEach((ob) => {
          setting[ob.que_key] = ob.answer;
        });
      }
      options[ele.name] = {
        selection: ele.show,
        expand: ele.expand,
        ...setting,
      };
      sort_options[ele.name] = ele.position;
    });
    let payload = {
      user_id: appointmentData?.doctor_id,
      clinic_id: clinicId ? clinicId : user_id,
      section_type: "ePrescriptions",
      filter_options: options,
      sort_options: sort_options,
      default_erx_template_id: templateId ?? defaultTemplateId,
    };
    handleApiLoaders("userSettings", true);
    c2cPostApiHandler(UPDATE_USER_SETTINGS, payload).then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          C2CConsole.log(res);
          handleApiLoaders("userSettings", false);
          getTemplatesApi();
        } else {
          handleApiLoaders("userSettings", false);
        }
      } else {
        handleApiLoaders("userSettings", false);
      }
    });
  };

  const updateDrugOrMedication = (updatedDrugList, templateSelectedForDrug) => {
    let addedDeletedDrugList = [];
    if (updatedDrugList) {
      addedDeletedDrugList = [...updatedDrugList];
    } else {
      addedDeletedDrugList = [...drugList?.value, ...deletedDrug];
    }
    const modifyPayload = getPayloadForDrug(
      addedDeletedDrugList,
      prescription_id
    );

    let reqPayload = {
      template_selected: templateSelectedForDrug,
      doctor_id: user_id,
      data: [...modifyPayload],
    };
    handleApiLoaders("drugs", true);
    const addUpdateDrugResponse = addUpdatePrescriptionData(
      reqPayload,
      GET_PRESCRIPTION_ID + "/" + prescription_id + "/medications",
      "put"
    ); //Fetch API Data

    addUpdateDrugResponse.then(([res, error]) => {
      if (!error) {
        setDeletedDrug([]);
        if (templateSelectedForDrug) {
          saveDrugData(res?.data?.data ? res.data.data : [], false, false);
        }

        setIsTemplateSelected(false);
        handleApiLoaders("drugs", false);
        handleApiLoaders("drugSearch", false);
      } else {
        setDeletedDrug([]);
        handleApiLoaders("drugs", false);
        handleApiLoaders("drugSearch", false);
      }
    });
  };

  const getGetDrugsDataAPI = (id, callAPI) => {
    let params = {
      doctor_id: user_id,
    };
    const drugDataResponse = c2cGetApiHandler(
      GET_PRESCRIPTION_ID + "/" + id + "/get-medications",
      params
    ); //Fetch API Data
    drugDataResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          const {
            frequencyArr,
            durationArr,
            detailsArr,
            quantityArr,
            unitArr,
          } = getDrugDropDownOptions(res?.data);
          setFrequencyOption(frequencyArr);
          setDurationOptions(durationArr);
          setFrequencyDetailsOption(detailsArr);
          setQuantityOption(quantityArr);
          setUnitOptions(unitArr);
          saveDrugData(res?.data?.medications, callAPI);
        }
      }
    });
  };

  const getVaccineChartAPI = (
    prescriptionId,
    isShared,
    callAPI,
    templateSelceted
  ) => {
    let api = GET_VACCINE_CHART + "/" + prescriptionId + "/vaccine_chart";
    const vaccineChartResponse = c2cGetApiHandler(api, isShared);
    vaccineChartResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          if (templateSelceted) {
            setVaccineNotes({
              call_api: callAPI ? callAPI : false,
              value: "",
            });
          } else {
            setVaccineNotes({
              call_api: callAPI ? callAPI : false,
              value: res?.data?.vaccine_notes ? res?.data?.vaccine_notes : "",
            });
          }
        }
      }
    });
  };

  const handleVaccineNotes = (value) => {
    setVaccineNotes({ call_api: true, value: value });
  };

  const handleCaptureDeletedDrug = (arr) => {
    let newArr = [...deletedDrug, ...arr];
    setDeletedDrug(newArr);
  };

  const handleApproveAndShareRX = () => {
    setApproveAndShareLoader(true);
    let payload = {
      "authorizer-principal-id": {
        user_type: "1",
        user_id: appointmentData?.doctor_id
          ? appointmentData?.doctor_id
          : user_id,
      },
      user_id: appointmentData?.doctor_id
        ? appointmentData?.doctor_id
        : user_id,
      appointment_id: appointmentData?.appointment_id,
    };
    c2cPostApiHandler(GET_SAVED_E_PRESCRIPTIONS, payload).then(
      ([res, error]) => {
        if (!error) {
          if (res?.data?.statusCode === 200) {
            let saved_prescription_id =
              res?.data?.data[0]?.saved_prescription_id;
            let reqPayload = {
              "authorizer-principal-id": {
                user_id: user_id,
                user_type: "1",
              },
              prescription_id: saved_prescription_id
                ? saved_prescription_id
                : prescription_id,
              appointment_id: appointmentData?.appointment_id,
            };
            const shareRXResponse = c2cPostApiHandler(
              APPROVE_AND_SHARE_ERX,
              reqPayload
            ); //Fetch API Data
            shareRXResponse.then(([response, shareRX_error]) => {
              if (!shareRX_error && res?.data?.statusCode === 200) {
                console.log("APPROVE_AND_SHARE_ERX", response);
                setApproveAndShareLoader(false);
                setShowPrescriptionShareModal(true);
              }
            });
          }
        }
      }
    );
  };

  const callSuggestedListAPI = () => {
    getDrugsSugesstionApi();
    getInstructionSuggestionList();
    getPatientHistorySuggestionList();
  };

  const getDrugsSugesstionApi = () => {
    c2cGetApiHandler(GET_DRUGS_SUGGESTIONS + "/" + user_id).then(
      ([res, error]) => {
        if (!error) {
          if (res?.data?.statusCode === 200) {
            let data = res?.data?.suggested_drugs;
            data.forEach((drug, ind) => {
              drug.id = ind;
              drug.selected = false;
              drug.duration = drug.duration
                ?.replace("NaN", "")
                ?.replace("undefined", "")
                ?.trim();
              drug.frequency_extended =
                drug.frequency_extended !== ""
                  ? drug.frequency_extended
                  : {
                      title: "",
                      details: "",
                    };
            });
            setDrugsSuggestionList([...data]);
          }
        }
      }
    );
  };

  const getInstructionSuggestionList = () => {
    const suggestionListResponse = c2cGetApiHandler(
      GET_INSTRUCTION_SUGGESTIONS + "/" + user_id
    );
    suggestionListResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        if (res?.data?.suggested_instructions?.length > 0) {
          res.data.suggested_instructions.forEach((element) => {
            element["selected"] = false;
          });
          setInstructionSuggestionList(res?.data?.suggested_instructions);
        }
      }
    });
  };

  const getPatientHistorySuggestionList = () => {
    const suggestionListResponse = c2cGetApiHandler(
      GET_PATIENT_HISTORY_SUGGESTIONS + "/" + user_id
    );
    suggestionListResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        Object.entries(phcSuggestionObj).forEach(([key]) => {
          phcSuggestionObj[key] = saveSuggestionList(res?.data[key + "_rev"]);
        });
        setPHCSuggestionObj({ ...phcSuggestionObj });
      }
    });
  };

  const handleSaveTemplateAPICall = (force_override) => {
    let filterEmptyReports =
      reportList?.value?.length > 0 &&
      reportList?.value.filter(
        (report) => report.title || report.value || report.description
      );
    let filterEmptyDiagnosis =
      diagnosisList?.value?.length > 0 &&
      diagnosisList?.value.filter(
        (diagnosis) =>
          diagnosis.title || diagnosis.value || diagnosis.description
      );
    let requestPayload = {
      doctor_id: user_id,
      clinic_id: clinicId,
      prescription_id: prescription_id,
      template_name: templateName?.name?.trim(),
      force_override: force_override,
      doctor_diagnosis: filterEmptyDiagnosis ? filterEmptyDiagnosis : [],
      examinations: filterEmptyReports ? filterEmptyReports : [],
      medications: [...drugList?.value],
      suggested_investigations_extended: getSuggestedInvestigationPayload(
        "suggested_investigation",
        followUp?.value
      ),
      suggested_investigations_description: getInstructionAndNotesPayload(
        "instructions_and_notes",
        followUp?.value
      ),
      chief_complaints: getHistoryAndComplaintPayload(
        "chief_complaints",
        patient_history_and_complaints?.value
      ),
      obstetric_history: getObstetricHistoryPayload(obstetricHistoryList),
      custom_sections: getCustomSectionsValue(customSection?.value),
    };
    const templateResponse = c2cPostApiHandler(SAVE_TEMPLATE, requestPayload);
    templateResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        setSavePrescriptionTemplate(false);
        setIsChecked(false);
        setTemplateError(false);
        getTemplatesApi();
        setShowAlertPopup(true);
        setTimeout(() => {
          setShowAlertPopup(false);
        }, 3000);
        setSelectedTemplate({ name: templateName?.name, id: templateName?.id });
      }
    });
  };

  const getDefaultTemplateData = (templateId) => {
    let payload = {
      template_id: templateId,
    };
    c2cPostApiHandler(GET_ERX_TEMPLATE_DATA, payload).then(([res, error]) => {
      processTemplateData(res, error);
    });
  };

  const getObstetricDetails = () => {
    return {
      lmp_date: obstetricDetails?.lmpDate,
      edd_date: obstetricDetails?.eddDate,
      cycle_length: obstetricDetails?.cycleLength,
      ega_weeks: obstetricDetails?.egaWeeks,
      ega_days: obstetricDetails?.egaDays,
      note: obstetricDetails?.note,
    };
  };

  const getCustomSectionsValue = (customSectionList) => {
    let customSectionPayload = [];
    if (Object.keys(customSectionList)?.length > 0) {
      Object.entries(customSectionList).forEach(([key, value]) => {
        let obj = { ...value };
        obj["custom_name"] = key?.replace("Custom", "custom");
        customSectionPayload.push(obj);
      });
    } else {
      customSectionPayload = [];
    }
    return customSectionPayload;
  };

  const saveCustomSectionData = (customSectionData, callAPI) => {
    let custom_section = {};
    erxComponents.forEach((data) => {
      if (data?.name?.includes("CustomSection")) {
        data.expand = false;
      }
    });
    setErxComponents([...erxComponents]);
    let customErxComponent = erxComponents.filter((data) =>
      data?.name.includes("CustomSection")
    );
    if (customSectionData?.length > 0) {
      customSectionData.forEach((data, ind) => {
        let key = Object.hasOwnProperty("custom_name")
          ? data?.custom_name?.charAt(0)?.toUpperCase() +
            data?.custom_name?.slice(1)
          : `CustomSection${ind + 1}`;
        custom_section[key] = data;
      });
      setCustomSection({
        call_api: callAPI,
        value: custom_section,
      });
      customErxComponent.forEach((data) => {
        let index = erxComponents.findIndex((erx) => erx.name === data?.name);
        if (index > -1) {
          erxComponents[index].expand = false;
          erxComponents[index].show = Object.keys(custom_section).includes(
            data?.name
          )
            ? true
            : false;
          erxComponents[index].title = custom_section[data.name]?.custom_title;
        }
      });
      setErxComponents([...erxComponents]);
    } else {
      erxComponents.forEach((erx) => {
        if (erx?.name?.includes("CustomSection")) {
          erx.show = false;
          erx.title = "Custom Section";
        }
      });
      setErxComponents([...erxComponents]);
      setCustomSection({
        ...customSection,
        call_api: callAPI,
        value: {},
      });
    }
  };
  const handleSetSelectionTemplate = (val) => {
    setSelectedSectionTemp(val);
    templatesList.forEach((template) => {
      template.selected = false;
    });
    setTemplatesList([...templatesList]);
    handleRemoveTemplateName();
  };

  // <===

  // Display UI ===>

  const displayERXHeader = () => {
    return (
      <ERXViewHeader
        showPrescriptionHome={showPrescriptionHome}
        templatesList={templatesList}
        pastConsultationsList={pastConsultationsList}
        addRecordList={addRecordList}
        selectedTemplate={selectedTemplate}
        updatedGender={updatedGender}
        allowedObstetricDetailsSpecializations={
          allowedObstetricDetailsSpecializations
        }
        doctorSpecialization={doctorSpecialization}
        previewLoader={previewLoader}
        handleShowPrescriptionsHome={handleShowPrescriptionsHome}
        handleClose={handleClose}
        handleSelectedTemplate={handleSelectedTemplate}
        handleSelectedPastConsultation={handleSelectedPastConsultation}
        handleSelectRecord={handleSelectRecord}
        handleSetDefaultTemplate={handleSetDefaultTemplate}
        handlePatientName={handlePatientName}
        handlePatientAge={handlePatientAge}
        handleGender={handleGender}
        patientDetails={patientDetails}
        getPatientDetailsApi={getPatientDetailsApi}
        genderOptions={genderOptions}
        patientAge={patientAge}
        appointmentData={appointmentData}
        handleSaveAndPreview={handleSaveAndPreview}
        patientPhoneNo={patientPhoneNo}
        templateError={templateError}
        isChecked={isChecked}
        displaySaveTemplate={displaySaveTemplate}
        setSavePrescriptionTemplate={setSavePrescriptionTemplate}
        savePrescriptionTemplate={savePrescriptionTemplate}
        getTemplatesApi={getTemplatesApi}
        patientDetailsName={patientDetailsName}
        handleRemoveTemplateName={handleRemoveTemplateName}
        setPatientDetailsPopupOpen={setPatientDetailsPopupOpen}
        isPatientDetailsPopupOpen={isPatientDetailsPopupOpen}
        handleClosePopup={handleClosePopup}
        handleTemplateCancel={handleTemplateCancel}
      />
    );
  };

  // Home ==>

  const displayCreatePrescription = () => {
    return (
      <div>
        {selectedTemplate?.name && (
          <div className="prescription-saved-tamplate-wrapper">
            <div className="prescription-tamplate-title">
              Template Name :
              <span className="prescription-tamplate-name">
                {selectedTemplate?.name}
              </span>
            </div>
          </div>
        )}
        <ERXMain
          erxComponents={erxComponents}
          appointmentData={appointmentData}
          vitalsForPrefill={vitalsForPrefill}
          patient_history_and_complaints={patient_history_and_complaints}
          diagnosisList={diagnosisList}
          reportList={reportList}
          drugList={drugList}
          frequencyOptions={frequencyOptions}
          frequencyDetailsOptions={frequencyDetailsOptions}
          durationOptions={durationOptions}
          quantityOptions={quantityOptions}
          unitOptions={unitOptions}
          prescription_id={prescription_id}
          followUp={followUp}
          doctorsPastNotes={doctorsPastNotes}
          followUpDate={followUpDate}
          doctorNote={doctorNote}
          maxApiCallForNotes={maxApiCallForNotes}
          selectedDays={selectedDays}
          frequencyList={frequencyList}
          dragOverItem={dragOverItem}
          dragItem={dragItem}
          showSettingUi={showSettingUi}
          vitalsList={vitalsList}
          addEditVitals={addEditVitals}
          includeErx={includeErx}
          editedPayload={editedPayload}
          updatedGender={updatedGender}
          pastVitalsSetting={pastVitalsSetting}
          draggable={draggable}
          includeInErx={includeErx}
          phcSuggestionObj={phcSuggestionObj}
          drugsSuggestionList={drugsSuggestionList}
          instructionSuggestionList={instructionSuggestionList}
          obstetricHistoryList={obstetricHistoryList}
          customSection={customSection}
          obstetricDetails={obstetricDetails}
          doctorSpecialization={doctorSpecialization}
          allowedObstetricDetailsSpecializations={
            allowedObstetricDetailsSpecializations
          }
          setObstetricDetails={setObstetricDetails}
          selectedSectionTemp={selectedSectionTemp}
          sectionalTemplateList={sectionalTemplateList}
          selectedTemplate={selectedTemplate?.name}
          toggleSections={toggleSections}
          handleOnDrag={handleOnDrag}
          handlePatientHistoryAndComplaints={handlePatientHistoryAndComplaints}
          handleDiagnosis={handleDiagnosis}
          handleReport={handleReport}
          handleEditCall={handleEditCall}
          handleDrugData={handleDrugData}
          handleFollowUp={handleFollowUp}
          updateDiagnosis={updateDiagnosis}
          setFollowUpDate={setFollowUpDate}
          setDoctorNote={setDoctorNote}
          getDoctorsPastNotes={getDoctorsPastNotes}
          setSelectedDays={setSelectedDays}
          drop={drop}
          onDragStart={onDragStart}
          onDragEnter={onDragEnter}
          settingIconClick={settingIconClick}
          handleSetting={handleSetting}
          setVitalsList={setVitalsList}
          afterFetchingVitals={afterFetchingVitals}
          setEditedPayload={setEditedPayload}
          getPastConsultationsApi={getPastConsultationsApi}
          handleCaptureDeletedDrug={handleCaptureDeletedDrug}
          setDraggable={setDraggable}
          saveVitals={saveVitals}
          handleUpdateAPICall={handleUpdateAPICall}
          updateFollowUpDate={updateFollowUpDate}
          updateDrugOrMedication={updateDrugOrMedication}
          setAddEditVitals={setAddEditVitals}
          getGetDrugsDataAPI={getGetDrugsDataAPI}
          handleOnChangeObstetricHistory={handleOnChangeObstetricHistory}
          handleAddCustomSection={handleAddCustomSection}
          handleCustomSection={handleCustomSection}
          handleEditLabel={handleEditLabel}
          handleDeleteCustomSection={handleDeleteCustomSection}
          setSelectedSectionTemp={handleSetSelectionTemplate}
          onSectionTempSave={onSectionTempSave}
          onSectionTempDelete={onSectionTempDelete}
          getSectionalTemplates={getSectionalTemplates}
          handleApiLoaders={handleApiLoaders}
          setIsTemplateSelected={setIsTemplateSelected}
        />
      </div>
    );
  };

  // Files ===>

  const displayPrescriptionFiles = () => {
    return (
      <div className="prescription-files-container">
        <div className="prescription-file-header">
          <div className="prescription-heading">Prescription Files</div>
          <div className="prescription-max-size-header">
            Max File size : 20 MB
          </div>
        </div>
        <div className="prescription-files-content-wrapper">
          <FilesView
            appointmentData={appointmentData}
            docList={docList}
            handleOnDrag={handleOnDrag}
            handleFileChange={handleFileChange}
            setDocList={setDocList}
          />
        </div>
      </div>
    );
  };

  // Vaccine chart ==>

  const displayVaccineChart = () => {
    return (
      <div>
        <VCView
          vaccineList={vaccineList}
          patientDob={patientDob}
          generalVaccineList={generalVaccineList}
          vaccineNotes={vaccineNotes}
          appointmentData={appointmentData}
          isAgeAboveSixteen={isAgeAboveSixteen}
          vitalsList={vaccineVitalsList}
          searchVaccine={searchVaccine}
          updatedGender={updatedGender}
          prescription_id={prescription_id}
          addEditVitals={addEditVitals}
          prescriptionVitals={vitalsList}
          patientDetails={patientDetails}
          setVaccineList={setVaccineList}
          setGeneralVaccineList={setGeneralVaccineList}
          setSearchVaccine={setSearchVaccine}
          setLoader={setLoader}
          fetchVitals={fetchVitals}
          getVaccines={getVaccines}
          handleVaccineNotes={handleVaccineNotes}
          handleUpdateAPICall={handleUpdateAPICall}
        />
      </div>
    );
  };

  // Upload manual prescription ==>

  const displayPrescriptions = () => {
    return (
      <div className="prescription-past-save-share-container">
        <div className="prescription-past-save-share-header">
          <div className="upload-manual-prescription-heading">
            Upload Manual Prescription
          </div>
          <div className="upload-max-file-size-text">Max File size : 20 MB</div>
        </div>
        <div className="past-save-share-wrapper">
          <UMPView
            appointmentData={appointmentData}
            fileList={fileList}
            setFileList={setFileList}
            defaultPharmacy={defaultPharmacy}
            pharmacyList={pharmacyList}
            setAlertMessage={setAlertMessage}
            handleOnDrag={handleOnDrag}
            handleFileChange={handleFileChange}
            handleDeleteFile={handleDeleteFile}
            handleSharePharmacyBtn={handleSharePharmacyBtn}
            {...props}
          />
          {displaySavedSharedPrescription()}
          {displayPastPrescriptions()}
        </div>
      </div>
    );
  };

  const displaySavedSharedPrescription = () => {
    return (
      <div className="erx-view-container-past-prescription">
        <div className="prescription-past-header">
          <div className="past-prescription-heading">
            Saved & Shared Prescription
          </div>
          {window.innerWidth < 767 && (
            <img
              src={CollapseIcon}
              alt=""
              onClick={toggleSaveSharedPrescription}
              className={
                "erx-main-section-header-arrow " +
                (!hideShowShareSavedPrescription
                  ? "erx-main-section-header-up-arrow"
                  : "erx-main-section-header-down-arrow")
              }
            />
          )}
        </div>
        {!hideShowShareSavedPrescription && (
          <div className="prescription-past-content">
            <SSPView
              {...props}
              pharmacyList={pharmacyList}
              appointmentData={appointmentData}
              handleEditCall={handleEditCall}
              getPastConsultationsApi={getPastConsultationsApi}
              includeInErx={includeErx}
              prescription_id={prescription_id}
              handleSharePharmacyBtn={handleSharePharmacyBtn}
            />
          </div>
        )}
      </div>
    );
  };

  const displayPastPrescriptions = () => {
    return (
      <div className="erx-view-container-past-prescription">
        <div className="prescription-past-header">
          <div className="past-prescription-heading">Past Prescription</div>

          {window.innerWidth < 767 && (
            <img
              src={CollapseIcon}
              alt=""
              onClick={togglePastPrescription}
              className={
                "erx-main-section-header-arrow " +
                (!hideShowPastPrescription
                  ? "erx-main-section-header-up-arrow"
                  : "erx-main-section-header-down-arrow")
              }
            />
          )}
        </div>
        {!hideShowPastPrescription && (
          <div className="prescription-past-content">
            <PastPrescription
              appointmentData={appointmentData}
              prescription_id={createdPrescriptionId}
            />
          </div>
        )}
      </div>
    );
  };

  const displayERXFooter = () => {
    return (
      <ERXViewFooter
        templateError={templateError}
        isChecked={isChecked}
        previewLoader={previewLoader}
        handleSaveAndPreview={handleSaveAndPreview}
        displaySaveTemplate={displaySaveTemplate}
      />
    );
  };

  const displaySaveTemplate = () => {
    return (
      <SaveTemplateView
        templateError={templateError}
        isChecked={isChecked}
        templateName={templateName?.name}
        selectedTemplate={selectedTemplate?.name}
        toggleCheckbox={toggleCheckbox}
        handleTemplateName={handleTemplateName}
        handleTemplateSave={handleTemplateSave}
        handleTemplateCancel={handleTemplateCancel}
        handleOverrideTemplateNo={handleOverrideTemplateNo}
        handleOverrideTemplateYes={handleOverrideTemplateYes}
      />
    );
  };

  const displayErxPreview = () => {
    return (
      <ERXMiniMapping
        erxComponents={erxComponents}
        vitalsList={vitalsList}
        patient_history_and_complaints={patient_history_and_complaints}
        diagnosisList={diagnosisList}
        reportList={reportList}
        drugList={drugList}
        followUpDate={followUpDate}
        followUp={followUp}
        doctorNote={doctorNote}
        vaccineNotes={vaccineNotes}
        updatedGender={updatedGender}
        obstetricHistoryList={obstetricHistoryList}
        customSection={customSection}
        obstetricDetails={obstetricDetails}
        doctorSpecialization={doctorSpecialization}
        allowedObstetricDetailsSpecializations={
          allowedObstetricDetailsSpecializations
        }
        handleRedirect={handleRedirect}
      />
    );
  };

  const displayGrowthChart = () => {
    return (
      <GrowthChart
        erxComponents={erxComponents}
        callGrowthChartVitals={callGrowthChartVitals}
        appointmentData={appointmentData}
        patientDetails={patientDetails}
        vitalsList={vitalsList}
        showEditGrowthChart={showEditGrowthChart}
        showSettingUi={showSettingUi}
        toggleSections={toggleSections}
        handleOpenPrintChartPopup={handleOpenPrintChartPopup}
        settingIconClick={settingIconClick}
        handleSetting={handleSetting}
        setCallGrowthChartVitals={setCallGrowthChartVitals}
        fetchVitals={fetchVitals}
        getVaccines={getVaccines}
        handleApiLoaders={handleApiLoaders}
      />
    );
  };

  const displayBackToErxPopup = () => {
    return (
      openBackToErxPopup && (
        <div className="grow-chart-redirect-popup">
          <CommonPopup
            openPopup={openBackToErxPopup}
            componentSpecificPopup={true}
            titleImg={warning}
            title={getTitle()}
            handleClosePopup={handleCloseBackToErxPopup}
            handleLeftBtnClick={() => {
              handleCloseBackToErxPopup();
              handleGrowthChart();
              handleRedirectToErx();
            }}
            handleRightBtnClick={handleCloseBackToErxPopup}
          />
        </div>
      )
    );
  };

  const displayPrintChartPopup = () => {
    return (
      openPrintChartPopup && (
        <div className="print-chart-popup">
          <CommonPopup
            openPopup={openPrintChartPopup}
            componentSpecificPopup={true}
            hideCloseText={true}
            titleImg={question}
            title="Do you want to print Charts?"
            leftBtn="No"
            rightBtn="Yes"
            handleClosePopup={handleClosePrintChartPopup}
            handleLeftBtnClick={handleNo}
            handleRightBtnClick={handleYes}
          />
        </div>
      )
    );
  };

  const displayHtmlPreview = () => {
    return (
      <>
        {showPreviewModal && (
          <ErxPreviewContainerView
            appointmentData={appointmentData}
            vaccineList={vaccineList}
            pharmacyList={pharmacyList}
            defaultPharmacy={defaultPharmacy}
            setAlertMessage={setAlertMessage}
            generalVaccineList={generalVaccineList}
            prescription_id={prescription_id}
            includeErx={includeErx}
            vitalsList={vitalsList}
            patient_history_and_complaints={patient_history_and_complaints}
            diagnosisList={diagnosisList}
            reportList={reportList}
            followUpDate={followUpDate}
            followUp={followUp}
            updatedGender={updatedGender}
            obstetricHistoryList={obstetricHistoryList}
            customSection={customSection}
            obstetricDetails={obstetricDetails}
            doctorSpecialization={doctorSpecialization}
            allowedObstetricDetailsSpecializations={
              allowedObstetricDetailsSpecializations
            }
            approveAndShareLoader={approveAndShareLoader}
            handleClose={handleClosePreview}
            handleCloseErx={handleClose}
            handleApproveAndShareRX={handleApproveAndShareRX}
            disablePreview={disablePreview}
            appointment_id={appointmentData?.appointment_id}
            handleDisablePreview={handleDisablePreview}
            callSuggestedListAPI={callSuggestedListAPI}
            handleSharePharmacyBtn={handleSharePharmacyBtn}
          />
        )}
      </>
    );
  };

  // <===

  return (
    <Drawer
      anchor={"right"}
      open={drawerOpen}
      PaperProps={{
        sx: {
          width: "100%",
          overflow: window.innerWidth < 767 ? "" : "hidden",
          height: "fit-content",
          overflowY: "hidden",
        },
      }}
      className="erx-view-container"
    >
      {loader && <Loader />}
      {displayERXHeader()}
      <div className="erx-minimap-tabs-wrapper">
        {window.innerWidth > 767 ? displayErxPreview() : ""}
        <>
          <div className="erx-prescription-tab-content-wrapper">
            {showPrescriptionHome === SELECTED_TAB_LIST.HOME &&
              displayCreatePrescription()}
            {showPrescriptionHome === SELECTED_TAB_LIST.FILES &&
              displayPrescriptionFiles()}
            {showPrescriptionHome === SELECTED_TAB_LIST.VACCINE_CHART &&
              displayVaccineChart()}
            {showPrescriptionHome === SELECTED_TAB_LIST.GROWTH_CHART &&
              displayGrowthChart()}
            {showPrescriptionHome === SELECTED_TAB_LIST.PRESCRIPTION &&
              displayPrescriptions()}
            {window.innerWidth < 767 && displayERXFooter()}
          </div>
        </>
      </div>
      {showPrescriptionShareModal && (
        <PrescriptionSharedModal
          appointment_id={appointmentData?.appointment_id}
          prescription_id={prescription_id}
          show={showPrescriptionShareModal}
          onHide={() => {
            closeSharedPopup();
          }}
          okayClickHandler={() => {
            closeSharedPopup();
            callAllAPI();
            setErxComponentOpen(false);
          }}
          sharePEMClickHandler={async () => {
            closeSharedPopup();
            callAllAPI();
            setShowPEMPopUp(true);
          }}
        />
      )}
      {showAlertPopup && <AlertMsgPopup alertMsg={alertMesg} />}
      {showPEMPopUp && (
        <PEMShareContentPopUp
          patientId={appointmentData?.patient_id}
          pemCloseBtnCallback={pemCloseBtnCallback}
          pemSuggestedKeyFromPrescription={getPemSuggestedKey}
          setErxComponentOpen={setErxComponentOpen}
        />
      )}
      {showPopUp && (
        <Popup
          title={"Patient Education Content Shared!"}
          show={showPopUp}
          handleClose={() => setShowPopUp(false)}
        />
      )}
      {displayBackToErxPopup()}
      {displayPrintChartPopup()}
      {displayHtmlPreview()}
      <ShareWithPharmacyPopup
        openPopup={showSharePopUp}
        disableShareBtn={!isAnyPharmacySelected}
        pharmacyList={pharmacyList}
        handleClosePopup={handleCloseSharePopup}
        handleSelectPharmacy={handleSelectPharmacy}
        handleSharePharmacy={handleSharePharmacy}
      />
      {alertMessage.show && (
        <StaffAlertMessagePopup
          alertMsg={alertMessage}
          handleClose={handleCloseAlertMsg}
        />
      )}
    </Drawer>
  );
};

export default ERXViewContainer;
